
const CHAT_ASSISTANT_CONFIG_URL = './config/chatAssistant.json';
const DEFAULT_CHAT_ASSISTANT_CONFIG = {
    welcomeMessage: 'Ciao, sono il tuo assistente per il foglio di calcolo, sono qui per assisterti in qualsiasi operazione tu desideri',
    systemPrompt: 'Sei PROMIUM CALC AI. Rispondi in italiano in modo chiaro usando il contesto tabellare solo se utile.',
    contextLabel: 'Contesto foglio (tabella markdown)',
    chatTitle: 'PROMIUM CALC AI'
};
const CHAT_INPUT_PLACEHOLDER = 'Fai domanda...';
const CHAT_INPUT_PROCESSING_PLACEHOLDER = 'Sto elaborando ⌛';
let chatAssistantConfigPromise = null;
let promptFrontendConfigPromise = null;

function normalizeChatAssistantConfig(rawConfig) {
    const config = Object.assign({}, DEFAULT_CHAT_ASSISTANT_CONFIG);
    if (!rawConfig || typeof rawConfig !== 'object') return config;
    ['welcomeMessage', 'systemPrompt', 'contextLabel', 'chatTitle'].forEach(function (key) {
        const value = rawConfig[key];
        if (typeof value === 'string' && value.trim()) {
            config[key] = value.trim();
        }
    });
    return config;
}

function loadChatAssistantConfig(forceRefresh = false) {
    if (!forceRefresh && chatAssistantConfigPromise) return chatAssistantConfigPromise;
    chatAssistantConfigPromise = fetch(CHAT_ASSISTANT_CONFIG_URL, { cache: 'no-store' })
        .then(function (response) {
            if (!response.ok) throw new Error('Configurazione assistente non disponibile');
            return response.json();
        })
        .then(function (rawConfig) {
            return normalizeChatAssistantConfig(rawConfig);
        })
        .catch(function () {
            return Object.assign({}, DEFAULT_CHAT_ASSISTANT_CONFIG);
        });
    return chatAssistantConfigPromise;
}

function loadPromptFrontendConfig(forceRefresh = false) {
    if (!forceRefresh && promptFrontendConfigPromise) return promptFrontendConfigPromise;
    promptFrontendConfigPromise = fetch('/api/frontend-config', { cache: 'no-store' })
        .then(function (response) {
            if (!response.ok) throw new Error('Configurazione prompt non disponibile');
            return response.json();
        })
        .then(function (config) {
            return {
                enablePromptLibrary: !!(config && config.enable_prompt_library)
            };
        })
        .catch(function () {
            return {
                enablePromptLibrary: false
            };
        });
    return promptFrontendConfigPromise;
}

export function initChat() {
    if (!isNeedChat()) {
        return
    }
    loadChatAssistantConfig();
    loadPromptFrontendConfig();

    // Your CSS as text
    let styles = `
body { }

#chat-assistant-container {
    position: fixed;
    right: 32px;
    bottom: 80px;
    z-index:999999;
}

#chat-assistant-button {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: linear-gradient(135deg, #6A7FDB, #3AC5A9);
    box-shadow: 0 12px 24px rgba(0,0,0,0.18);
    color: #fff;
    transition: transform .2s ease, box-shadow .2s ease;
}

#chat-assistant-button:hover { transform: translateY(-2px); box-shadow: 0 16px 28px rgba(0,0,0,0.22); }

#chat-container {
    position: fixed;
    padding: 12px;
    top: 45%;
    left: 50%;
    z-index:99999;
    transform: translate(-50%, -50%);
    display: none;
    flex-direction: column;
    border-radius: 14px;
    width: 72vw;
    height: 78vh;
    min-width: 520px;
    min-height: 480px;
    box-sizing: border-box;
    resize: both;
    overflow: hidden;
    background: rgba(255,255,255,0.65);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255,255,255,0.6);
    box-shadow: 0 24px 48px rgba(0,0,0,0.22);
}
#chat-menu-button {
    border: none;
    background: transparent;
    font-size: 18px;
    cursor: pointer;
    color: #495057;
    padding: 6px 8px;
    border-radius: 6px;
    margin-right: 6px;
}
#chat-menu-button:hover { background: rgba(0,0,0,0.06); }
#chat-sidebar {
    position: absolute;
    left: 12px;
    top: 56px;
    bottom: 12px;
    width: var(--sidebar-w, 240px);
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    box-shadow: 0 6px 16px rgba(0,0,0,0.08);
    overflow-y: auto;
    display: none;
    z-index: 3;
}
#chat-sidebar.open { display: block; }
#chat-sidebar .conv-item {
    display: flex; align-items: center; justify-content: space-between;
    padding: 10px; border-bottom: 1px solid #f1f3f5; gap: 8px;
    cursor: pointer;
}
#chat-sidebar .conv-item.active { background: #f8f9fa; }
#chat-sidebar .conv-title { font-size: 13px; font-weight: 600; color:#212529; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
#chat-sidebar .conv-meta { font-size: 11px; color:#868e96; }
#chat-sidebar .conv-actions { display:flex; gap:6px; }
#chat-sidebar .conv-actions button {
    border:none; background:transparent; cursor:pointer; font-size:14px; color:#868e96; padding:4px; border-radius:4px;
}
#chat-sidebar .conv-actions button:hover { background:#f1f3f5; color:#495057; }

#chat-container.chat-sidebar-open #chat-messages { margin-left: calc(var(--sidebar-w, 240px) + 8px); }
#chat-container.chat-sidebar-open #chat-footer-stack { left: calc(12px + var(--sidebar-w, 240px) + 8px); }
#chat-messages {
    flex: 1 1 auto;
    min-height: 120px;
    overflow-y: auto;
    margin: 6px 0;
    padding: 8px;
    background: rgba(255,255,255,0.85);
    border-radius: 8px;
    color:#222;
    padding-bottom: calc(12px + var(--chat-input-h, 64px));
}

@media (max-width: 768px) {
  #chat-container {
    width: 95%;
    height: 88vh;
    min-width: 320px;
    min-height: 320px;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    --sidebar-w: 76vw;
  }
  #chat-messages {
    max-height: 45vh !important;
  }
  #chat-container.promium-workbench-opened {
    width: 95vw !important;
    height: auto !important;
    max-height: 90vh !important;
    overflow-y: auto !important;
    padding-bottom: 12px !important;
  }
  #chat-container.promium-workbench-opened #chat-header,
  #chat-container.promium-workbench-opened #chat-messages,
  #chat-container.promium-workbench-opened #chat-footer-stack,
  #chat-container.promium-workbench-opened #chat-input-container {
    width: 100% !important;
  }
  #promium-workbench-panel {
    position: static !important;
    width: 100% !important;
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
    bottom: auto !important;
    padding-left: 0 !important;
    border-left: none !important;
    border-radius: 14px !important;
  }
  #promium-workbench-panel .wb-main {
    flex-direction: column !important;
    gap: 12px !important;
  }
  #promium-workbench-panel .wb-left,
  #promium-workbench-panel .wb-right {
    width: 100% !important;
  }
  #promium-workbench-panel .wb-left {
    max-height: 40vh !important;
    overflow-y: auto !important;
  }
  #promium-workbench-panel .wb-right {
    max-height: 50vh !important;
    overflow-y: auto !important;
  }
  #wb-preview-box {
    max-height: 36vh !important;
  }
  #wb-prompt-list {
    max-height: 40vh !important;
  }
}


#chat-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 10px 10px 6px;
    border-radius: 12px 12px 0 0;
    cursor: move;
}

#chat-container.promium-workbench-opened #circle-button { display:none; }

#action-mode-wrapper { display:flex; align-items:center; gap:8px; }
#action-mode-label { font-size:12px; font-weight:600; color:#1a1a1a; }
.switch { position:relative; display:inline-block; width:34px; height:18px; }
.switch input { opacity:0; width:0; height:0; }
.switch .slider { position:absolute; top:0; left:0; right:0; bottom:0; background:#ddd; border-radius:12px; transition:background .2s ease; cursor:pointer; }
.switch .slider:before { position:absolute; content:""; height:14px; width:14px; left:2px; top:2px; background:#fff; border-radius:50%; transition:transform .2s ease; }
.switch input:checked + .slider { background:#3AC5A9; }
.switch input:checked + .slider:before { transform: translateX(16px); }
#action-mode-badge { font-size:12px; padding:2px 6px; border-radius:8px; background:rgba(58,197,169,.15); color:#0a7f44; display:none; }
#action-mode-badge.on { display:inline-block; }

#loading-indicator {
    width: 14px;
    height: 14px;
    margin: 0 10px 0 10px;
    border: 2px solid #ccc;
    border-top-color: #4caf50;
    border-radius: 50%;
    animation: spin 2s linear infinite;
    visibility: hidden;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

#chat-header .show-loading {
    visibility: visible;
}

#chat-header .hide-loading {
    visibility: hidden;
}


#circle-button {
    padding: 0;
    border: none;
    background-color: transparent;
    font-size: 16px;
    user-select: none;
    display: flex;
    align-items: center;
    color: #1a1a1a;
    font-weight: 700;
    letter-spacing: .2px;
}

#close-button {
    cursor: pointer;
    padding: 0;
    border: none;
    background-color: transparent;
    font-size: 24px;
    color: #333;
}
#send-button {
    cursor: pointer;
    padding: 0;
    border: none;
    background-color: transparent;
    font-size: 16px;
}

#close-button:hover,
#send-button:hover {
    color: #888;
}

#chat-footer-stack {
    position: absolute;
    left: 12px;
    right: 28px; /* lascia libero l’angolo per il resize handle */
    bottom: 28px; /* lascia libero l’angolo per il resize handle */
    display: flex;
    flex-direction: column;
    gap: 8px;
    z-index: 2;
}

#chat-input-container,
#chat-input {
    border: none;
}

#chat-input-container {
    display: flex;
    align-items: center;
    border-radius: 14px;
    background: rgba(255,255,255,0.92);
    padding: 12px;
    border: 1px solid rgba(0,0,0,0.06);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
    position: relative;
}

#chat-input {
    flex: 1;
    padding: 0;
    margin-right: 8px;
    border-radius: 8px;
    overflow-y: hidden; /* Default hidden, gestito dinamicamente */
    max-height: 120px; /* Limite massimo altezza */
    height: 28px;
    font-size: 1rem;
    outline: none;
    resize: none;
    background: transparent;
    line-height: 1.4; /* Migliore leggibilità */
}

#send-button {
    background-color: transparent;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    width: 32px;
}

#send-button>span {
    height: 16px;
    width: 16px;
}

#send-button:enabled {
    background-color: #3AC5A9;
}

#send-button:enabled svg path {
    fill: #fff;
}

#send-button:disabled {
    background-color: #dee2e6;
    opacity: 0.55;
    cursor: not-allowed;
    pointer-events: none;
}

#send-button:disabled svg path {
    fill: #868e96;
}

#chat-selection-indicator {
    position: absolute;
    top: 54px;
    left: 50%;
    transform: translate(-50%, -8px);
    background: rgba(34, 139, 230, 0.95);
    color: #fff;
    padding: 6px 12px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    box-shadow: 0 8px 18px rgba(34, 139, 230, 0.28);
    z-index: 5;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease, transform 0.2s ease;
}

#chat-selection-indicator.show {
    opacity: 1;
    transform: translate(-50%, 0);
}

#chat-active-choice {
    display: none;
    align-items: center;
    gap: 6px;
    pointer-events: none;
}

#chat-active-choice.show {
    display: flex;
}

#chat-active-choice .choice-pill {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    padding: 6px 10px;
    border-radius: 999px;
    background: rgba(58, 98, 197, 0.12);
    border: 1px solid rgba(58, 98, 197, 0.2);
    color: #1c4fa3;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#chat-prompt-builder {
    display: none;
    flex-direction: column;
    gap: 10px;
    max-height: 164px;
    overflow-y: auto;
    padding: 12px 14px;
    border-radius: 14px;
    background: linear-gradient(180deg, rgba(255,255,255,0.94) 0%, rgba(248,250,252,0.96) 100%);
    border: 1px solid rgba(148, 163, 184, 0.22);
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
}

#chat-prompt-builder.open {
    display: flex;
}

.chat-prompt-builder-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.chat-prompt-builder-title {
    font-size: 12px;
    font-weight: 700;
    color: #334155;
}

.chat-prompt-builder-subtitle {
    font-size: 11px;
    color: #64748b;
}

.chat-prompt-builder-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.chat-prompt-builder-empty {
    width: 100%;
    font-size: 12px;
    color: #64748b;
    background: rgba(255,255,255,0.72);
    border: 1px dashed rgba(148, 163, 184, 0.35);
    border-radius: 12px;
    padding: 10px 12px;
}

.chat-prompt-option {
    border: 1px solid rgba(96, 165, 250, 0.28);
    background: rgba(255,255,255,0.88);
    color: #1d4ed8;
    border-radius: 999px;
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
    min-height: 34px;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.08);
}

.chat-prompt-option:hover,
.chat-prompt-option:focus {
    background: #eff6ff;
    border-color: rgba(59, 130, 246, 0.5);
    transform: translateY(-1px);
    box-shadow: 0 8px 18px rgba(37, 99, 235, 0.14);
    outline: none;
}

.ai-markdown h1, .ai-markdown h2, .ai-markdown h3, .ai-markdown h4, .ai-markdown h5, .ai-markdown h6 { margin: 8px 0; color: #222; }
.ai-markdown p { margin: 6px 0; color: #222; }
.ai-markdown pre { background: rgba(0,0,0,0.06); padding: 8px; border-radius: 6px; overflow: auto; }
.ai-markdown code { background: rgba(0,0,0,0.06); padding: 2px 4px; border-radius: 4px; }
.ai-markdown ul, .ai-markdown ol { margin: 6px 0 6px 18px; }
.ai-markdown a { color: #3A62C5; text-decoration: none; }
.ai-markdown a:hover { text-decoration: underline; }
.ai-markdown .chat-math-block {
    margin: 8px 0;
    padding: 10px 12px;
    background: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 10px;
    overflow-x: auto;
    text-align: center;
    line-height: 1.7;
    font-family: "Cambria Math", "Times New Roman", serif;
}
.ai-markdown .chat-math-line + .chat-math-line { margin-top: 6px; }
.ai-markdown .chat-math-text { white-space: nowrap; }
.ai-markdown .chat-fraction {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    vertical-align: middle;
    margin: 0 0.18em;
}
.ai-markdown .chat-frac-top {
    display: block;
    padding: 0 0.28em 0.08em;
    border-bottom: 1px solid currentColor;
}
.ai-markdown .chat-frac-bottom {
    display: block;
    padding: 0.08em 0.28em 0;
}

/* ============================================
   CHAT BUBBLES - Stili per messaggi utente/AI
   ============================================ */

/* Container messaggio utente - allineato a destra */
.chat-msg-user {
    display: flex;
    justify-content: flex-end;
    margin: 8px 4px;
    animation: fadeInUp 0.3s ease;
}

/* Bolla messaggio utente */
.chat-msg-user .chat-bubble {
    max-width: 80%;
    background: linear-gradient(135deg, #228be6, #1971c2);
    color: white;
    padding: 10px 14px;
    border-radius: 16px 16px 4px 16px;
    font-size: 13px;
    line-height: 1.5;
    box-shadow: 0 2px 8px rgba(34, 139, 230, 0.25);
    word-wrap: break-word;
}

.chat-choice-badge {
    display: inline-flex;
    align-items: center;
    margin-bottom: 6px;
    padding: 3px 8px;
    border-radius: 999px;
    background: rgba(34, 139, 230, 0.12);
    color: #1c4fa3;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.02em;
}

/* Container messaggio AI - allineato a sinistra */
.chat-msg-ai {
    display: flex;
    justify-content: flex-start;
    margin: 8px 4px;
    animation: fadeInUp 0.3s ease;
}

/* Bolla messaggio AI */
.chat-msg-ai .chat-bubble {
    max-width: 85%;
    background: #f8f9fa;
    color: #212529;
    padding: 14px 14px 12px;
    border-radius: 16px 16px 16px 4px;
    font-size: 13px;
    line-height: 1.5;
    border: 1px solid #e9ecef;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    word-wrap: break-word;
    position: relative;
}

.chat-msg-ai .chat-bubble.has-copy {
    padding-top: 38px;
}

.chat-copy-button {
    position: absolute;
    top: 8px;
    right: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 62px;
    min-height: 28px;
    padding: 4px 10px;
    border: 1px solid #d0d7de;
    border-radius: 999px;
    background: #fff;
    color: #495057;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.chat-copy-button:hover,
.chat-copy-button:focus {
    background: #eef7ff;
    color: #1c4fa3;
    border-color: #74c0fc;
    outline: none;
}

/* Label sotto la bolla (timestamp, tipo) */
.chat-bubble-label {
    font-size: 10px;
    color: #868e96;
    margin-top: 4px;
    padding: 0 4px;
}

.chat-msg-user .chat-bubble-label {
    text-align: right;
}

.chat-msg-ai .chat-bubble-label {
    text-align: left;
}

/* Animazione fade in */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Bottone Clear History */
#clear-history-btn {
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 11px;
    padding: 4px 8px;
    border-radius: 4px;
    color: #868e96;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 4px;
}

#clear-history-btn:hover {
    background: rgba(250, 82, 82, 0.1);
    color: #fa5252;
}

/* Separatore per azioni eseguite */
.chat-action-result {
    margin: 4px 0;
    padding: 8px 12px;
    background: rgba(64, 192, 87, 0.1);
    border-left: 3px solid #40c057;
    border-radius: 0 6px 6px 0;
    font-size: 12px;
    color: #2b8a3e;
}

.chat-action-error {
    margin: 4px 0;
    padding: 8px 12px;
    background: rgba(250, 82, 82, 0.1);
    border-left: 3px solid #fa5252;
    border-radius: 0 6px 6px 0;
    font-size: 12px;
    color: #c92a2a;
}

#prompt-lib-button {
    border: none !important;
    background: transparent !important;
    cursor: pointer;
    font-size: 12px;
    padding: 6px 10px !important;
    border-radius: 6px !important;
    color: #495057 !important;
    font-weight: 600;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
}

#prompt-lib-button:hover {
    background: rgba(0,0,0,0.05) !important;
    color: #228be6 !important;
}
`

    if (!document.getElementById('promium-chat-style')) {
        let styleSheet = document.createElement("style")
        styleSheet.id = 'promium-chat-style'
        styleSheet.innerText = styles
        document.head.appendChild(styleSheet)
    }


    const html = `<div id="chat-assistant-container">
            <button id="chat-assistant-button">🤖AI</button>
        </div>
    
        <div id="chat-container">
            <div id="chat-header">
                <button id="chat-menu-button" title="Conversazioni">☰</button>
                <span id="circle-button"><span id="chat-title-text">PROMIUM CALC AI</span><div id="loading-indicator"></div></span>
                <div id="action-mode-wrapper">
                    <button id="prompt-lib-button" title="Libreria Prompt">
                        <span style="font-size:16px;">📚</span>
                        <span>Libreria Prompt</span>
                    </button>
                    <div style="width:1px; height:16px; background:#dee2e6; margin:0 8px;"></div>
                    <span id="action-mode-label">Modalità azione</span>
                    <label class="switch"><input id="action-mode-toggle" type="checkbox" /><span class="slider"></span></label>
                    <span id="action-mode-badge">ON</span>
                    <div style="width:1px; height:16px; background:#dee2e6; margin:0 8px;"></div>
                    <!-- Nuova chat: crea una nuova conversazione senza cancellare le precedenti -->
                    <button id="clear-history-btn" title="Nuova chat">
                        <span>➕</span>
                        <span>Nuova chat</span>
                    </button>
                </div>
                <button id="close-button" title="Riduci a icona">—</button>
            </div>
            <div id="chat-selection-indicator" aria-live="polite"></div>
            <div id="chat-sidebar"></div>
            <div id="chat-messages"></div>
            <div id="chat-footer-stack">
                <div id="chat-active-choice" aria-live="polite"></div>
                <div id="chat-prompt-builder" aria-label="Prompt predefiniti"></div>
                <div id="chat-input-container">
                    <textarea id="chat-input" placeholder="${CHAT_INPUT_PLACEHOLDER}"></textarea>
                    <!-- <textarea id="chat-input" placeholder="请输入问题"></textarea> -->
                    <button id="send-button" disabled>
                        <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" class="h-4 w-4 m-1 md:m-0"
                                stroke-width="2">
                                <path
                                    d="M.5 1.163A1 1 0 0 1 1.97.28l12.868 6.837a1 1 0 0 1 0 1.766L1.969 15.72A1 1 0 0 1 .5 14.836V10.33a1 1 0 0 1 .816-.983L8.5 8 1.316 6.653A1 1 0 0 1 .5 5.67V1.163Z"
                                    fill="currentColor"></path>
                            </svg></span>
                    </button>
                    <i id="debug-csv-btn" class="fas fa-file-excel" style="position:absolute; bottom:-22px; left:12px; font-size:13px; color:#adb5bd; cursor:pointer; opacity:0.6; z-index:10;" title="Debug: Vedi dati CSV inviati all'AI"></i>
                </div>
            </div>
    
        </div>`;

    function getEl(id) { return document.getElementById(id); }

    // Helpers need to be available for attachChatEvents
    function updateActionBadge(badge, isActionMode) {
        if (!badge) return;
        if (isActionMode) {
            badge.classList.add('on');
        } else {
            badge.classList.remove('on');
        }
    }

    function resetButton(input, sendButton) {
        if (!sendButton) sendButton = getEl('send-button');
        if (!sendButton) return;

        const isBusy = sendButton.dataset.busy === '1';
        const hasHiddenPrompt = !!(input && input.dataset && input.dataset.hiddenPromptActive === '1');

        if (isBusy) {
            sendButton.disabled = true;
            sendButton.setAttribute('disabled', 'true');
            sendButton.classList.remove('enabled');
            return;
        }

        if ((input.value.trim() !== '') || hasHiddenPrompt) {
            sendButton.disabled = false;
            sendButton.removeAttribute('disabled');
            sendButton.classList.add('enabled');
        } else {
            input.style.height = '24px';
            sendButton.disabled = true;
            sendButton.setAttribute('disabled', 'true');
            sendButton.classList.remove('enabled');
        }
    }

    function inputHandler(input, sendButton) {
        // Reset altezza per ricalcolare scrollHeight corretto in caso di cancellazione
        input.style.height = 'auto';
        
        // Imposta altezza basata su scrollHeight, con limite massimo
        const maxHeight = 120; // circa 5-6 righe
        const newHeight = Math.min(input.scrollHeight, maxHeight);
        
        input.style.height = newHeight + 'px';
        
        // Gestione scrollbar se supera altezza massima
        if (input.scrollHeight > maxHeight) {
            input.style.overflowY = 'auto';
        } else {
            input.style.overflowY = 'hidden';
        }

        resetButton(input, sendButton)
        try {
            if (window.PROMIUM_CHAT && typeof window.PROMIUM_CHAT.updateInputSpacer === 'function') {
                window.PROMIUM_CHAT.updateInputSpacer();
            }
        } catch(_) {}
    }

    function clamp(chatContainer) {
        if (!chatContainer) return;
        const margin = 8;
        const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

        let rect = null;
        try { rect = chatContainer.getBoundingClientRect(); } catch (e) { rect = null; }
        const w = chatContainer.offsetWidth || (rect ? rect.width : 0) || 0;
        const h = chatContainer.offsetHeight || (rect ? rect.height : 0) || 0;

        let left = parseInt(chatContainer.style.left || '', 10);
        let top = parseInt(chatContainer.style.top || '', 10);
        if (isNaN(left)) left = rect ? rect.left : (vw - w) / 2;
        if (isNaN(top)) top = rect ? rect.top : (vh - h) / 2;

        const maxLeft = Math.max(margin, vw - w - margin);
        const maxTop = Math.max(margin, vh - h - margin);
        left = Math.max(margin, Math.min(maxLeft, left));
        top = Math.max(margin, Math.min(maxTop, top));

        chatContainer.style.left = left + 'px';
        chatContainer.style.top = top + 'px';
        chatContainer.style.transform = 'none';
        if (window.PROMIUM_CHAT) window.PROMIUM_CHAT.pos = { left, top };
    }

    function attachChatEvents() {
        const assistantButton = getEl('chat-assistant-button');
        const chatContainer = getEl('chat-container');
        const closeButton = getEl('close-button');
        const chatInput = getEl('chat-input');
        const sendButton = getEl('send-button');
        const loadingIndicator = getEl('loading-indicator');
        const messagesBox = getEl('chat-messages');
        const actionToggle = getEl('action-mode-toggle');
        const actionBadge = getEl('action-mode-badge');
        const promptLibButton = getEl('prompt-lib-button');
        const promptBuilder = getEl('chat-prompt-builder');
        const activeChoice = getEl('chat-active-choice');
        const selectionIndicator = getEl('chat-selection-indicator');
        const chatHeader = getEl('chat-header');
        const wrap = getEl('action-mode-wrapper');
        const menuButton = getEl('chat-menu-button');
        const sidebar = getEl('chat-sidebar');

        if (!assistantButton || !chatContainer) return;

        function scrollToMessageTop(box, el) {
            if (!box || !el) return;
            try {
                el.scrollIntoView({ block: 'start', inline: 'nearest' });
            } catch (e) {
                box.scrollTop = el.offsetTop - (box.offsetTop || 0);
            }
        }

        window.PROMIUM_CHAT = window.PROMIUM_CHAT || {};
        window.PROMIUM_CHAT.buildSheetContext = collectSheetDataAsCSV;
        window.PROMIUM_CHAT.runtime = window.PROMIUM_CHAT.runtime || {
            requestInFlight: false,
            promptStateByConversation: {},
            promptTitleRegistry: null,
            promptLibrary: [],
            promptLibraryLoaded: false,
            promptLibraryPromise: null,
            promptLibraryEnabled: false,
            promptLibraryConfigLoaded: false
        };
        const runtime = window.PROMIUM_CHAT.runtime;
        window.PROMIUM_CHAT.updateInputSpacer = function() {
            const cont = getEl('chat-container');
            const inputWrap = getEl('chat-input-container');
            if (!cont || !inputWrap) return;
            const h = Math.max(48, inputWrap.offsetHeight || 0);
            cont.style.setProperty('--chat-input-h', h + 'px');
        };

        function updatePromptLibraryVisibility() {
            const isEnabled = !!runtime.promptLibraryEnabled;
            if (promptLibButton) {
                promptLibButton.style.display = isEnabled ? 'flex' : 'none';
            }
            // Non nascondiamo più il prompt builder se la libreria è disabilitata,
            // i suggerimenti devono essere mostrati indipendentemente dal flag
        }

        async function ensurePromptLibraryConfig(forceRefresh) {
            if (!forceRefresh && runtime.promptLibraryConfigLoaded) return runtime.promptLibraryEnabled;
            const config = await loadPromptFrontendConfig(!!forceRefresh);
            runtime.promptLibraryEnabled = !!(config && config.enablePromptLibrary);
            runtime.promptLibraryConfigLoaded = true;
            updatePromptLibraryVisibility();
            return runtime.promptLibraryEnabled;
        }

        function derivePromptTitleFromText(text) {
            const normalized = String(text || '')
                .replace(/\s+/g, ' ')
                .replace(/[#:>*`_-]+/g, ' ')
                .trim();
            if (!normalized) return 'Prompt salvato';
            const sentence = normalized.split(/[.!?]/)[0].trim() || normalized;
            const compact = sentence.slice(0, 42).trim();
            return compact.length < sentence.length ? compact + '...' : compact;
        }

        function loadPromptTitleRegistry() {
            if (runtime.promptTitleRegistry) return runtime.promptTitleRegistry;
            try {
                const saved = JSON.parse(localStorage.getItem('PROMIUM_CHAT_PROMPT_TITLES') || '{}');
                runtime.promptTitleRegistry = saved && typeof saved === 'object' ? saved : {};
            } catch (_) {
                runtime.promptTitleRegistry = {};
            }
            return runtime.promptTitleRegistry;
        }

        function savePromptTitleRegistry() {
            try {
                localStorage.setItem('PROMIUM_CHAT_PROMPT_TITLES', JSON.stringify(runtime.promptTitleRegistry || {}));
            } catch (_) { }
        }

        function buildPromptDescriptor(rawPrompt) {
            const registry = loadPromptTitleRegistry();
            const promptText = String((rawPrompt && (rawPrompt.prompt_text || rawPrompt.prompt || rawPrompt.text)) || '').trim();
            const promptId = String((rawPrompt && (rawPrompt.id || rawPrompt.prompt_id || rawPrompt.uuid)) || derivePromptTitleFromText(promptText));
            const explicitTitle = String(
                (rawPrompt && (
                    rawPrompt.prompt_title ||
                    rawPrompt.title ||
                    rawPrompt.name ||
                    rawPrompt.label
                )) || ''
            ).trim();
            const title = explicitTitle || registry[promptId] || derivePromptTitleFromText(promptText);

            if (!registry[promptId]) {
                registry[promptId] = title;
                savePromptTitleRegistry();
            }

            var config = {};
            if (rawPrompt && rawPrompt.configuration) {
                try {
                    config = (typeof rawPrompt.configuration === 'string') ? JSON.parse(rawPrompt.configuration) : rawPrompt.configuration;
                } catch(e) {}
            }

            return {
                id: promptId,
                title: title,
                content: promptText,
                isSuggestion: !!(rawPrompt && rawPrompt.is_suggestion),
                isDisabled: !!config.isDisabled,
                autoPasteText: config.autoPasteText || '',
                contextOptions: promptContextOptions(config)
            };
        }

        function getPromptConversationState() {
            const conv = ensureConversation();
            const convId = conv && conv.id ? conv.id : 'default';
            if (!runtime.promptStateByConversation[convId]) {
                runtime.promptStateByConversation[convId] = {
                    dismissed: false,
                    selectedPrompt: null,
                    // Opzioni di contesto dell'ultimo prompt inviato in questa
                    // conversazione: valgono anche per i messaggi successivi
                    // (es. la risposta a "quale grammatura?"), che altrimenti
                    // partirebbero con un contesto diverso da quello su cui il
                    // prompt ragiona — la selezione si azzera a ogni invio.
                    contextOptions: null,
                    workbenchConfigAtPrompt: undefined
                };
            }
            return runtime.promptStateByConversation[convId];
        }

        // Opzioni del contesto per il prossimo invio: quelle del prompt scelto,
        // altrimenti quelle dell'ultimo prompt usato nella conversazione — a
        // meno che dopo l'operatore abbia applicato una configurazione dal
        // Workbench (menuLoader.js sostituisce PROMIUM_WB_LAST_CONFIG con un
        // oggetto nuovo): vale la scelta più recente.
        // Sempre una copia: collectSheetDataAsCSV completa l'oggetto che riceve.
        function contextOptionsForNextRequest() {
            const state = getPromptConversationState();
            const selected = state.selectedPrompt && state.selectedPrompt.contextOptions;
            if (selected) return Object.assign({}, selected);
            if (state.contextOptions && state.workbenchConfigAtPrompt === window.PROMIUM_WB_LAST_CONFIG) {
                return Object.assign({}, state.contextOptions);
            }
            return {};
        }

        async function activeCompanyId() {
            try {
                if (window.PROMIUM_COMPANY_PROMISE) await window.PROMIUM_COMPANY_PROMISE;
            } catch (_) { }
            return (window.PROMIUM_COMPANY && window.PROMIUM_COMPANY.id) || '';
        }

        function clearPromptSelection() {
            const state = getPromptConversationState();
            state.selectedPrompt = null;
            if (chatInput) {
                delete chatInput.dataset.hiddenPromptActive;
            }
            if (activeChoice) {
                activeChoice.classList.remove('show');
                activeChoice.innerHTML = '';
            }
            resetButton(chatInput, sendButton);
        }

        function syncPromptSelectionUi() {
            const state = getPromptConversationState();
            if (chatInput) {
                if (state.selectedPrompt && state.selectedPrompt.content) {
                    chatInput.dataset.hiddenPromptActive = '1';
                } else {
                    delete chatInput.dataset.hiddenPromptActive;
                }
            }
            if (activeChoice) {
                if (state.selectedPrompt && state.selectedPrompt.title) {
                    activeChoice.innerHTML = `<span class="choice-pill">Scelta: ${escapeHtml(state.selectedPrompt.title)}</span>`;
                    activeChoice.classList.add('show');
                } else {
                    activeChoice.classList.remove('show');
                    activeChoice.innerHTML = '';
                }
            }
            resetButton(chatInput, sendButton);
        }

        function showSelectionIndicator(title) {
            if (!selectionIndicator || !title) return;
            selectionIndicator.textContent = 'Scelta: ' + title;
            selectionIndicator.classList.add('show');
            if (runtime.selectionIndicatorTimeout) {
                clearTimeout(runtime.selectionIndicatorTimeout);
            }
            runtime.selectionIndicatorTimeout = setTimeout(function () {
                selectionIndicator.classList.remove('show');
            }, 2200);
        }

        function hidePromptBuilder() {
            if (!promptBuilder) return;
            promptBuilder.classList.remove('open');
            promptBuilder.setAttribute('aria-hidden', 'true');
        }

        function markPromptBuilderDismissed() {
            const state = getPromptConversationState();
            state.dismissed = true;
            hidePromptBuilder();
        }

        async function copyTextToClipboard(text) {
            const value = String(text || '');
            if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function' && window.isSecureContext) {
                await navigator.clipboard.writeText(value);
                return;
            }

            const fallbackInput = document.createElement('textarea');
            fallbackInput.value = value;
            fallbackInput.setAttribute('readonly', 'true');
            fallbackInput.style.position = 'fixed';
            fallbackInput.style.opacity = '0';
            fallbackInput.style.pointerEvents = 'none';
            fallbackInput.style.left = '-9999px';
            document.body.appendChild(fallbackInput);
            fallbackInput.focus();
            fallbackInput.select();
            const copied = document.execCommand('copy');
            document.body.removeChild(fallbackInput);
            if (!copied) {
                throw new Error('Copia non riuscita');
            }
        }

        function buildMessagePayload(visibleText, selectedPrompt) {
            const cleanVisibleText = String(visibleText || '').trim();
            const hiddenSuffix = selectedPrompt && selectedPrompt.content ? String(selectedPrompt.content).trim() : '';
            if (!hiddenSuffix) return cleanVisibleText;
            return cleanVisibleText ? (cleanVisibleText + '\n\n' + hiddenSuffix) : hiddenSuffix;
        }

        function getPromptApiToken() {
            try {
        return sessionStorage.getItem('x-auth-token') || localStorage.getItem('x-auth-token') || 'bYrtGMlKH649wwRglPoCGplBgZv8NgDEnVom';
            } catch (_) {
        return 'bYrtGMlKH649wwRglPoCGplBgZv8NgDEnVom';
            }
        }

        async function loadPromptLibrary(forceRefresh) {
            await ensurePromptLibraryConfig(forceRefresh);

            if (!forceRefresh && runtime.promptLibraryLoaded) return runtime.promptLibrary;
            if (!forceRefresh && runtime.promptLibraryPromise) return runtime.promptLibraryPromise;

            const token = getPromptApiToken();
            const headers = token ? { 'Authorization': 'Bearer ' + token } : {};

            runtime.promptLibraryPromise = activeCompanyId()
                .then(function (companyId) {
                    // Solo i prompt della società attiva, come nel Workbench AI
                    // (menuLoader.js): i suggerimenti di una società non devono
                    // comparire nella chat di un'altra.
                    const url = '/api/prompts' + (companyId ? ('?company=' + encodeURIComponent(companyId)) : '');
                    return fetch(url, { headers: headers });
                })
                .then(function (response) {
                    if (!response.ok) throw new Error('Prompt non disponibili');
                    return response.json();
                })
                .then(function (data) {
                    const prompts = Array.isArray(data) ? data
                        .map(buildPromptDescriptor)
                        .filter(function (item) {
                            return item && item.content && item.isSuggestion;
                        }) : [];
                    runtime.promptLibrary = prompts;
                    runtime.promptLibraryLoaded = true;
                    return prompts;
                })
                .catch(function () {
                    runtime.promptLibrary = [];
                    runtime.promptLibraryLoaded = true;
                    return [];
                })
                .finally(function () {
                    runtime.promptLibraryPromise = null;
                });

            return runtime.promptLibraryPromise;
        }

        function renderPromptBuilder(prompts) {
            if (!promptBuilder) return;
            const headerHtml = `
                <div class="chat-prompt-builder-head">
                    <div class="chat-prompt-builder-title">Azioni proposte</div>
                    <div class="chat-prompt-builder-subtitle">Scrivi la richiesta una volta scelta una azione</div>
                </div>
            `;
            if (!prompts || prompts.length === 0) {
                promptBuilder.innerHTML = headerHtml + '<div class="chat-prompt-builder-empty">Nessun prompt suggerito disponibile.</div>';
                return;
            }

            promptBuilder.innerHTML = headerHtml;
            const optionsWrap = document.createElement('div');
            optionsWrap.className = 'chat-prompt-builder-grid';
            prompts.forEach(function (prompt) {
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'chat-prompt-option';
                button.textContent = prompt.title;
                button.setAttribute('data-prompt-id', prompt.id);
                button.setAttribute('aria-label', 'Usa prompt ' + prompt.title);
                
                if (prompt.isDisabled) {
                    button.disabled = true;
                    button.style.opacity = '0.5';
                    button.style.cursor = 'not-allowed';
                    button.title = "Azione disabilitata momentaneamente";
                } else {
                    button.onclick = function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        const state = getPromptConversationState();
                        state.selectedPrompt = prompt;
                        state.dismissed = true;
                        syncPromptSelectionUi();
                        showSelectionIndicator(prompt.title);
                        hidePromptBuilder();
                        if (chatInput) {
                            if (prompt.autoPasteText) {
                                const start = chatInput.selectionStart;
                                const end = chatInput.selectionEnd;
                                const val = chatInput.value;
                                const before = val.substring(0, start);
                                const after = val.substring(end, val.length);
                                chatInput.value = before + prompt.autoPasteText + after;
                                chatInput.selectionStart = chatInput.selectionEnd = start + prompt.autoPasteText.length;
                                try { chatInput.dispatchEvent(new Event('input', { bubbles: true })); } catch(e) {}
                            }
                            chatInput.focus();
                        }
                    };
                }
                optionsWrap.appendChild(button);
            });
            promptBuilder.appendChild(optionsWrap);
        }

        async function maybeShowPromptBuilder() {
            if (!promptBuilder || !chatInput) return;
            await ensurePromptLibraryConfig(false);
            
            const state = getPromptConversationState();
            if (state.dismissed || runtime.requestInFlight) {
                hidePromptBuilder();
                return;
            }

            // Nuova conversazione = c'è solo il messaggio di benvenuto nel DOM (1 child)
            if (messagesBox && messagesBox.children.length > 1) {
                state.dismissed = true;
                hidePromptBuilder();
                return;
            }

            promptBuilder.innerHTML = '<div class="chat-prompt-builder-empty">Caricamento prompt...</div>';
            promptBuilder.classList.add('open');
            promptBuilder.setAttribute('aria-hidden', 'false');
            const prompts = await loadPromptLibrary(false);
            if (state.dismissed) {
                hidePromptBuilder();
                return;
            }
            renderPromptBuilder(prompts);
            promptBuilder.classList.add('open');
            promptBuilder.setAttribute('aria-hidden', 'false');
        }

        function setRequestInFlight(isBusy) {
            runtime.requestInFlight = !!isBusy;
            if (loadingIndicator) {
                loadingIndicator.classList.toggle('show-loading', !!isBusy);
            }
            if (chatInput) {
                chatInput.placeholder = isBusy ? CHAT_INPUT_PROCESSING_PLACEHOLDER : CHAT_INPUT_PLACEHOLDER;
                chatInput.setAttribute('aria-busy', isBusy ? 'true' : 'false');
            }
            if (sendButton) {
                sendButton.dataset.busy = isBusy ? '1' : '0';
                if (isBusy) {
                    sendButton.disabled = true;
                    sendButton.setAttribute('disabled', 'true');
                    sendButton.setAttribute('aria-disabled', 'true');
                } else {
                    sendButton.removeAttribute('aria-disabled');
                    resetButton(chatInput, sendButton);
                }
            }
        }

        if (promptLibButton) {
            promptLibButton.onclick = function (e) {
                e.stopPropagation();
                if (!runtime.promptLibraryEnabled) return;
                if (window.PROMIUM_CALC_ACTIONS && window.PROMIUM_CALC_ACTIONS.openWorkbenchAI) {
                    window.PROMIUM_CALC_ACTIONS.openWorkbenchAI();
                } else {
                    alert("Workbench AI non disponibile.");
                }
            };
            promptLibButton.onmousedown = function (e) {
                e.stopPropagation();
            };
        }
        ensurePromptLibraryConfig(false);

        const debugCsvBtn = getEl('debug-csv-btn');
        if (debugCsvBtn) {
            debugCsvBtn.onclick = function(e) {
                e.stopPropagation();
                
                // Collect data exactly as it will be sent to the AI.
                const contextMarkdown = collectSheetDataAsCSV(contextOptionsForNextRequest());
                
                // Remove existing modal if any
                const modalId = 'promium-debug-modal';
                const existing = document.getElementById(modalId);
                if (existing) document.body.removeChild(existing);
                
                // Create modal overlay
                const modal = document.createElement('div');
                modal.id = modalId;
                modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99999;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(2px);';
                
                // Modal content
                const content = document.createElement('div');
                content.setAttribute("id", "debugsheet")
                content.style.cssText = 'background:white;width:90%;max-width:800px;height:80%;max-height:600px;border-radius:12px;display:flex;flex-direction:column;box-shadow:0 10px 25px rgba(0,0,0,0.2);overflow:hidden;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;animation:fadeInUp 0.2s ease;z-index:999999';
                
                // Header
                const header = document.createElement('div');
                header.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:15px 20px;border-bottom:1px solid #eee;background:#f8f9fa;';
                header.innerHTML = `
                    <div style="display:flex;align-items:center;gap:10px;">
                        <i class="fas fa-file-excel" style="color:#217346;font-size:18px;"></i>
                        <h3 style="margin:0;font-size:16px;font-weight:600;color:#333;">Debug Dati Inviati (Markdown)</h3>
                    </div>
                    <button id="close-debug-modal" style="border:none;background:transparent;font-size:24px;line-height:1;color:#adb5bd;cursor:pointer;padding:0 5px;">&times;</button>
                `;
                
                // Body
                const body = document.createElement('div');
                body.style.cssText = 'flex:1;overflow:hidden;padding:20px;display:flex;flex-direction:column;background:#fff;';
                
                // Info box
                const info = document.createElement('div');
                info.style.cssText = 'margin-bottom:15px;font-size:12px;padding:10px 15px;background:#e7f5ff;border-radius:6px;border:1px solid #d0ebff;color:#1971c2;line-height:1.4;';
                info.innerHTML = 'Questo è esattamente il formato markdown inviato all\'AI insieme alla tua domanda.<br>Le intestazioni possono includere anche la lettera colonna se configurata nel Workbench o nella Configurazione AI.';
                
                // Preformatted text
                const pre = document.createElement('pre');
                pre.style.cssText = 'flex:1;overflow:auto;background:#282c34;color:#abb2bf;padding:15px;border-radius:6px;font-size:12px;line-height:1.5;margin:0;border:1px solid #dee2e6;white-space:pre;font-family:"Fira Code", "Consolas", monospace;tab-size:4;';
                pre.textContent = contextMarkdown || '(Nessun dato trovato o foglio vuoto)';
                
                body.appendChild(info);
                body.appendChild(pre);
                content.appendChild(header);
                content.appendChild(body);
                modal.appendChild(content);
                
                // Append to body (outside chat container to avoid clipping)
                document.body.appendChild(modal);
                
                // Close handlers
                const closeBtn = header.querySelector('#close-debug-modal');
                const closeFn = () => {
                    modal.style.opacity = '0';
                    setTimeout(() => { if(modal.parentNode) modal.parentNode.removeChild(modal); }, 200);
                };
                
                closeBtn.onclick = closeFn;
                modal.onclick = function(e) { if(e.target === modal) closeFn(); };
                
                // Add simple fade in
                modal.animate([{opacity:0}, {opacity:1}], {duration:200, fill:'forwards'});
            };
        }

        let isActionMode = false;
        try {
            isActionMode = localStorage.getItem('PROMIUM_ACTION_MODE') === '1';
        } catch (e) { }
        if (actionToggle) actionToggle.checked = isActionMode;

        updateActionBadge(actionBadge, isActionMode);

        if (actionToggle) {
            actionToggle.onchange = function () {
                isActionMode = !!this.checked;
                try { localStorage.setItem('PROMIUM_ACTION_MODE', isActionMode ? '1' : '0'); } catch (e) { }
                updateActionBadge(actionBadge, isActionMode);
            };
        }

        if (wrap) {
            wrap.onclick = function (e) { e.stopPropagation(); };
            wrap.onmousedown = function (e) { e.stopPropagation(); };
        }

        assistantButton.onclick = function () {
            chatContainer.style.display = 'flex';
            if (!window.PROMIUM_CHAT) window.PROMIUM_CHAT = { open: true, pos: {}, mounted: true };
            window.PROMIUM_CHAT.open = true;
            requestAnimationFrame(function () {
                try { if (window.PROMIUM_CHAT.updateInputSpacer) window.PROMIUM_CHAT.updateInputSpacer(); } catch(_) {}
                const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                const w = chatContainer.offsetWidth || 0;
                const h = chatContainer.offsetHeight || 0;
                let left = (vw - w) / 2;
                let top = (vh - h) / 2;
                try {
                    if (window.PROMIUM_CHAT && window.PROMIUM_CHAT.pos) {
                        if (typeof window.PROMIUM_CHAT.pos.left === 'number') left = window.PROMIUM_CHAT.pos.left;
                        if (typeof window.PROMIUM_CHAT.pos.top === 'number') top = window.PROMIUM_CHAT.pos.top;
                    }
                } catch (e) { }
                chatContainer.style.left = Math.round(left) + 'px';
                chatContainer.style.top = Math.round(top) + 'px';
                chatContainer.style.transform = 'none';
                clamp(chatContainer);
            });
        };

        if (closeButton) {
            closeButton.onclick = function () {
                chatContainer.style.display = 'none';
                if (window.PROMIUM_CHAT) window.PROMIUM_CHAT.open = false;
            };
        }

        // =============================
        // GESTIONE CONVERSAZIONI MULTIPLE
        // =============================
        const CONV_LIST_KEY = 'PROMIUM_CHAT_CONVOS';
        const CURRENT_CONV_KEY = 'PROMIUM_CHAT_CURRENT';
        const HISTORY_PREFIX = 'PROMIUM_CHAT_HISTORY_';
        function uid(){ return 'c' + Math.random().toString(36).slice(2,6) + Date.now().toString(36); }
        function now(){ return Date.now(); }
        function formatDate(ts){
            try { return new Date(ts).toLocaleString('it-IT', { dateStyle:'short', timeStyle:'short' }); }
            catch(_) { return ''; }
        }
        function loadConversations(){
            try {
                const s = localStorage.getItem(CONV_LIST_KEY);
                const arr = s ? JSON.parse(s) : [];
                if (Array.isArray(arr)) return arr;
            } catch(_){}
            return [];
        }
        function saveConversations(list){
            try { localStorage.setItem(CONV_LIST_KEY, JSON.stringify(list)); } catch(_){}
        }
        function inferConversationTitle(history, fallbackTitle) {
            const base = (fallbackTitle && String(fallbackTitle).trim()) ? String(fallbackTitle).trim() : 'Nuova chat';
            if (!Array.isArray(history) || history.length === 0) return base;
            const firstUser = history.find(m => m && m.type === 'user' && String(m.text || '').trim());
            if (!firstUser) return base;
            const t = String(firstUser.text || '').trim().slice(0, 40);
            return t || base;
        }
        function normalizeConversationIndex() {
            let list = loadConversations();
            const byId = {};
            (Array.isArray(list) ? list : []).forEach(c => {
                if (!c || !c.id) return;
                byId[c.id] = {
                    id: c.id,
                    title: c.title || 'Nuova chat',
                    createdAt: Number(c.createdAt || now()),
                    updatedAt: Number(c.updatedAt || now())
                };
            });
            try {
                for (let i = 0; i < localStorage.length; i++) {
                    const k = localStorage.key(i);
                    if (!k || k.indexOf(HISTORY_PREFIX) !== 0) continue;
                    const id = k.slice(HISTORY_PREFIX.length);
                    if (!id) continue;
                    let history = [];
                    try {
                        const raw = localStorage.getItem(k);
                        const parsed = raw ? JSON.parse(raw) : [];
                        history = Array.isArray(parsed) ? parsed : [];
                    } catch (_) {}
                    const lastTs = history.length ? Number(history[history.length - 1].timestamp || now()) : now();
                    const firstTs = history.length ? Number(history[0].timestamp || lastTs) : lastTs;
                    const prev = byId[id];
                    byId[id] = {
                        id: id,
                        title: inferConversationTitle(history, prev && prev.title),
                        createdAt: prev ? Number(prev.createdAt || firstTs) : firstTs,
                        updatedAt: Math.max(Number(prev ? prev.updatedAt : 0), lastTs)
                    };
                }
            } catch (_) {}
            const normalized = Object.values(byId).sort((a, b) => Number(b.updatedAt || 0) - Number(a.updatedAt || 0));
            saveConversations(normalized);
            return normalized;
        }
        function getCurrentConversationId(){
            try { const id = localStorage.getItem(CURRENT_CONV_KEY); if (id) return id; } catch(_){}
            return null;
        }
        function setCurrentConversationId(id){
            try { localStorage.setItem(CURRENT_CONV_KEY, id); } catch(_){}
        }
        function ensureConversation(){
            let list = normalizeConversationIndex();
            let cur = getCurrentConversationId();
            if (!list || list.length===0){
                const id = uid();
                const conv = { id, title: 'Nuova chat', createdAt: now(), updatedAt: now() };
                list = [conv]; saveConversations(list); setCurrentConversationId(id);
                return conv;
            }
            if (!cur || !list.find(c=>c.id===cur)){
                cur = list[0].id; setCurrentConversationId(cur);
            }
            return list.find(c=>c.id===cur);
        }
        function createConversation(){
            const list = normalizeConversationIndex();
            const id = uid();
            const conv = { id, title: 'Nuova chat', createdAt: now(), updatedAt: now() };
            list.unshift(conv);
            saveConversations(list);
            setCurrentConversationId(id);
            return conv;
        }
        function renameConversation(id, title){
            const list = normalizeConversationIndex();
            const c = list.find(x=>x.id===id); if (!c) return;
            c.title = title || c.title; c.updatedAt = now();
            saveConversations(list);
        }
        function deleteConversation(id){
            let list = normalizeConversationIndex();
            list = list.filter(c=>c.id!==id);
            saveConversations(list);
            try { localStorage.removeItem(HISTORY_PREFIX + id); } catch(_){}
            if (getCurrentConversationId()===id){
                if (list.length>0){ setCurrentConversationId(list[0].id); }
                else { const conv = createConversation(); setCurrentConversationId(conv.id); }
            }
        }
        function switchConversation(id){
            setCurrentConversationId(id);
            clearPromptSelection();
            hidePromptBuilder();
            syncPromptSelectionUi();
            renderExistingHistory();
            renderSidebar();
        }
        function renderSidebar(){
            if (!sidebar) return;
            const list = normalizeConversationIndex();
            const cur = getCurrentConversationId();
            const escTitle = function(s){
                if (!s) return '';
                return String(s)
                  .replace(/&/g,'&amp;')
                  .replace(/</g,'&lt;')
                  .replace(/>/g,'&gt;')
                  .replace(/"/g,'&quot;');
            };
            const rows = list.map(c=>{
                const active = (c.id===cur) ? ' active' : '';
                const ts = formatDate(c.updatedAt);
                const icon = '💬';
                return `<div class="conv-item${active}" data-id="${c.id}">
                    <div style="flex:1; min-width:0;">
                        <div class="conv-title">${icon} ${escTitle(c.title)}</div>
                        <div class="conv-meta">${ts}</div>
                    </div>
                    <div class="conv-actions">
                        <button title="Rinomina" data-act="rename">✏️</button>
                        <button title="Elimina" data-act="delete">🗑️</button>
                    </div>
                </div>`;
            }).join('');
            sidebar.innerHTML = rows || '<div style="padding:10px; color:#868e96;">Nessuna conversazione</div>';
        }
        if (menuButton && sidebar){
            menuButton.onclick = function(e){
                e.stopPropagation();
                const isOpen = sidebar.classList.contains('open');
                if (isOpen){
                    sidebar.classList.remove('open');
                    chatContainer.classList.remove('chat-sidebar-open');
                } else {
                    renderSidebar();
                    sidebar.classList.add('open');
                    chatContainer.classList.add('chat-sidebar-open');
                    try { if (window.PROMIUM_CHAT.updateInputSpacer) window.PROMIUM_CHAT.updateInputSpacer(); } catch(_){}
                }
            };
            sidebar.onclick = function(e){
                const item = e.target.closest('.conv-item');
                if (!item) return;
                const id = item.getAttribute('data-id');
                const actBtn = e.target.closest('button');
                if (actBtn){
                    const act = actBtn.getAttribute('data-act');
                    if (act==='rename'){
                        const list = loadConversations();
                        const c = list.find(x=>x.id===id);
                        const nt = prompt('Rinomina conversazione', c ? c.title : '');
                        if (nt && nt.trim()){
                            renameConversation(id, nt.trim());
                            renderSidebar();
                        }
                        return;
                    }
                    if (act==='delete'){
                        if (confirm('Eliminare la conversazione selezionata?')){
                            deleteConversation(id);
                            renderExistingHistory();
                            renderSidebar();
                        }
                        return;
                    }
                }
                switchConversation(id);
            };
        }

        /**
             * ============================================
             * CHAT HISTORY MANAGEMENT
             * ============================================
             * La history viene salvata per conversazione su localStorage.
             * Chiave: PROMIUM_CHAT_HISTORY_<conversationId>
             * Formato: Array di oggetti { type: 'user'|'ai', text: string, timestamp: number }
             */
            function currentHistoryKey(){
                const cur = ensureConversation();
                return HISTORY_PREFIX + cur.id;
            }
            const MAX_HISTORY_ITEMS = 100; // Limite massimo messaggi salvati

            /**
             * Carica la history da localStorage
             * @returns {Array} Array di messaggi
             */
            function loadHistory() {
                try {
                    const stored = localStorage.getItem(currentHistoryKey());
                    if (stored) {
                        const parsed = JSON.parse(stored);
                        if (Array.isArray(parsed)) return parsed;
                    }
                } catch (e) {
                    console.warn('Errore caricamento chat history:', e);
                }
                return [];
            }

            /**
             * Salva la history su localStorage
             * @param {Array} history - Array di messaggi
             */
            function saveHistory(history) {
                try {
                    // Limita il numero di messaggi
                    const trimmed = history.slice(-MAX_HISTORY_ITEMS);
                    localStorage.setItem(currentHistoryKey(), JSON.stringify(trimmed));
                } catch (e) {
                    console.warn('Errore salvataggio chat history:', e);
                }
            }

            /**
             * Aggiunge un messaggio alla history
             * @param {string} type - 'user' o 'ai'
             * @param {string} text - Testo del messaggio
             */
            function addToHistory(type, text, meta) {
                const history = loadHistory();
                const historyItem = {
                    type: type,
                    text: text,
                    timestamp: Date.now()
                };
                if (meta && meta.fullText) historyItem.fullText = meta.fullText;
                if (meta && meta.promptTitle) historyItem.promptTitle = meta.promptTitle;
                history.push(historyItem);
                saveHistory(history);
                // aggiorna metadati conversazione
                try {
                    const list = loadConversations();
                    const curId = getCurrentConversationId();
                    const c = list.find(x=>x.id===curId);
                    if (c){
                        c.updatedAt = now();
                        // Autotitolo dalla prima frase utente se ancora "Nuova chat"
                        if (type==='user' && (c.title==='Nuova chat' || /^\s*$/.test(c.title))) {
                            const t = String(text).trim().slice(0, 32);
                            c.title = t || 'Nuova chat';
                        }
                        saveConversations(list);
                        renderSidebar();
                    }
                } catch (_){}
            }

            /**
             * Pulisce la history corrente (non più usata per Nuova chat)
             */
            function clearHistory() {
                try {
                    localStorage.removeItem(currentHistoryKey());
                } catch (e) { }
            }

            /**
             * Formatta timestamp in formato leggibile
             * @param {number} ts - Timestamp
             * @returns {string} Formato "HH:MM"
             */
            function formatTime(ts) {
                const d = new Date(ts);
                return d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
            }

            /**
             * Crea elemento DOM per messaggio utente
             * @param {string} text - Testo del messaggio
             * @param {number} timestamp - Timestamp del messaggio
             * @returns {HTMLElement}
             */
            function createUserMessageEl(text, timestamp, promptTitle) {
                const wrapper = document.createElement('div');
                wrapper.className = 'chat-msg-user';
                const badgeHtml = promptTitle ? `<div class="chat-choice-badge">Scelta: ${escapeHtml(promptTitle)}</div>` : '';
                wrapper.innerHTML = `
                    <div>
                        ${badgeHtml}
                        <div class="chat-bubble">${escapeHtml(text)}</div>
                        <div class="chat-bubble-label">${formatTime(timestamp)}</div>
                    </div>
                `;
                return wrapper;
            }

            /**
             * Crea elemento DOM per messaggio AI
             * @param {string} text - Testo del messaggio (markdown)
             * @param {number} timestamp - Timestamp del messaggio
             * @param {boolean} hideCopy - Nasconde il bottone copia
             * @param {boolean} isHtml - Testo come HTML nativo (non esegue markdown)
             * @returns {HTMLElement}
             */
            function createAIMessageEl(text, timestamp, hideCopy = false, isHtml = false) {
                const wrapper = document.createElement('div');
                wrapper.className = 'chat-msg-ai';
                const contentWrap = document.createElement('div');
                const bubble = document.createElement('div');
                bubble.className = 'chat-bubble ai-markdown';
                
                if (isHtml) {
                    bubble.innerHTML = text;
                } else {
                    bubble.innerHTML = renderMarkdown(text);
                }

                // Il bottone di copia vive solo sui messaggi AI (eccetto benvenuto) e usa fallback compatibile.
                if (!hideCopy) {
                    bubble.classList.add('has-copy');
                    const copyButton = document.createElement('button');
                    copyButton.type = 'button';
                    copyButton.className = 'chat-copy-button';
                    copyButton.textContent = 'Copia';
                    copyButton.setAttribute('aria-label', 'Copia il messaggio AI');
                    copyButton.onclick = async function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        const originalLabel = 'Copia';
                        try {
                            await copyTextToClipboard(text);
                            copyButton.textContent = 'Copiato!';
                        } catch (_) {
                            copyButton.textContent = 'Riprova';
                        }
                        clearTimeout(copyButton._restoreLabelTimeout);
                        copyButton._restoreLabelTimeout = setTimeout(function () {
                            copyButton.textContent = originalLabel;
                        }, 2000);
                    };

                    bubble.appendChild(copyButton);
                }

                const label = document.createElement('div');
                label.className = 'chat-bubble-label';
                label.textContent = 'AI • ' + formatTime(timestamp);

                contentWrap.appendChild(bubble);
                contentWrap.appendChild(label);
                wrapper.appendChild(contentWrap);
                return wrapper;
            }

            function showWelcomeMessage() {
                if (!messagesBox) return;
                loadChatAssistantConfig().then(function (config) {
                    if (!messagesBox || messagesBox.children.length > 0) return;
                    const el = createAIMessageEl(config.welcomeMessage, Date.now(), true, true);
                    messagesBox.appendChild(el);
                    scrollToMessageTop(messagesBox, el);
                });
            }

            /**
             * Escape HTML per sicurezza
             * @param {string} str - Stringa da escapare
             * @returns {string}
             */
            function escapeHtml(str) {
                if (!str) return '';
                return str.replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/\n/g, '<br>');
            }

            /**
             * Carica e mostra la history esistente nell'area messaggi
             */
            function renderExistingHistory() {
                if (!messagesBox) return;
                ensureConversation();
                const history = loadHistory();
                clearPromptSelection();
                if (history.length === 0) {
                    messagesBox.innerHTML = '';
                    showWelcomeMessage();
                    return;
                }
                messagesBox.innerHTML = '';
                history.forEach(msg => {
                    if (msg.type === 'user') {
                        messagesBox.appendChild(createUserMessageEl(msg.text, msg.timestamp, msg.promptTitle));
                    } else if (msg.type === 'ai') {
                        messagesBox.appendChild(createAIMessageEl(msg.text, msg.timestamp));
                    }
                });
                messagesBox.scrollTop = 0;
            }

            // Carica la history esistente all'init per la conversazione corrente
            // Evita di ricaricare la history ad ogni attach (MutationObserver)
            try {
                if (!window.PROMIUM_CHAT) window.PROMIUM_CHAT = { open: false, pos: { left: null, top: null }, mounted: true };
                if (!window.PROMIUM_CHAT.historyRendered) {
                    if (!window.PROMIUM_CHAT.autoConversationCreated) {
                        createConversation();
                        window.PROMIUM_CHAT.autoConversationCreated = true;
                    } else {
                        ensureConversation();
                    }
                    renderExistingHistory();
                    window.PROMIUM_CHAT.historyRendered = true;
                }
            } catch (e) {
                try {
                    if (!window.PROMIUM_CHAT.autoConversationCreated) {
                        createConversation();
                        window.PROMIUM_CHAT.autoConversationCreated = true;
                    } else {
                        ensureConversation();
                    }
                } catch(_) {}
                renderExistingHistory();
            }

            // Gestione bottone Clear History
            const clearHistoryBtn = getEl('clear-history-btn');
            if (clearHistoryBtn) {
                clearHistoryBtn.onclick = function (e) {
                    e.stopPropagation();
                    createConversation();
                    clearPromptSelection();
                    hidePromptBuilder();
                    if (messagesBox) {
                        messagesBox.innerHTML = '';
                        showWelcomeMessage();
                    }
                    renderSidebar();
                    try { if (window.PROMIUM_CHAT) window.PROMIUM_CHAT.historyRendered = true; } catch(_) {}
                };
                clearHistoryBtn.onmousedown = function (e) {
                    e.stopPropagation();
                };
            }

            /**
             * Costruisce il contesto per l'AI includendo la history recente
             * @returns {string} History formattata per il prompt
             */
            function buildHistoryContext() {
                const history = loadHistory();
                if (history.length === 0) return '';

                // Prendi gli ultimi 10 messaggi per contesto
                const recent = history.slice(-10);
                let ctx = '\n\n--- Cronologia conversazione precedente ---\n';
                recent.forEach(msg => {
                    const messageText = (msg && msg.type === 'user' && msg.fullText) ? msg.fullText : msg.text;
                    if (msg.type === 'user') {
                        ctx += `UTENTE: ${messageText}\n`;
                    } else if (msg.type === 'ai') {
                        ctx += `AI: ${messageText}\n`;
                    }
                });
                ctx += '--- Fine cronologia ---\n';
                return ctx;
            }

        if (sendButton && chatInput) {
            async function submitChatMessage() {
                const promptState = getPromptConversationState();
                const visibleMessage = chatInput.value;
                const promptSelection = promptState.selectedPrompt;
                const message = buildMessagePayload(visibleMessage, promptSelection);

                if (runtime.requestInFlight || message.trim() === '') return;

                // Letto PRIMA di clearPromptSelection(), che azzera la scelta.
                const contextOptions = contextOptionsForNextRequest();
                if (promptSelection && promptSelection.contextOptions) {
                    promptState.contextOptions = promptSelection.contextOptions;
                    promptState.workbenchConfigAtPrompt = window.PROMIUM_WB_LAST_CONFIG;
                }

                setRequestInFlight(true);
                markPromptBuilderDismissed();

                const displayMessage = visibleMessage.trim() || 'Richiesta con prompt predefinito';
                const promptTitle = promptSelection && promptSelection.title ? promptSelection.title : '';

                // Costruisci il contesto della history PRIMA di aggiungere il messaggio attuale
                const historyContextStr = buildHistoryContext();

                chatInput.value = '';
                clearPromptSelection();

                // Mostra subito il messaggio utente mantenendo invisibile il suffisso reale inviato all'AI.
                const userTimestamp = Date.now();
                messagesBox.appendChild(createUserMessageEl(displayMessage, userTimestamp, promptTitle));
                messagesBox.scrollTop = messagesBox.scrollHeight;

                // Salva sia il testo visibile sia il payload completo per il contesto delle richieste successive.
                addToHistory('user', displayMessage, {
                    fullText: message,
                    promptTitle: promptTitle
                });

                try {
                    // Costruisce il contesto una sola volta al submit:
                    // in questo modo preview, integrità e payload inviato restano perfettamente allineati.
                    const requestContext = collectSheetDataAsCSV(contextOptions);

                    // Check isActionMode from toggle element if available, else usage local
                    let currentMode = isActionMode;
                    if (actionToggle) currentMode = actionToggle.checked;

                    if (currentMode) {
                        // ============================================
                        // MODALITÀ AZIONE - Esegue script su Luckysheet
                        // ============================================
                        const fullMessageWithHistory = historyContextStr + '\n\n' + message;
                        const result = await chatAction(fullMessageWithHistory, requestContext);
                        const aiText = result && result.message ? result.message : '';
                        const aiTimestamp = Date.now();

                        // Mostra risposta AI
                        const aiEl = createAIMessageEl(aiText, aiTimestamp);
                        messagesBox.appendChild(aiEl);
                        // Porta in vista l'inizio della risposta, senza forzare la fine
                        scrollToMessageTop(messagesBox, aiEl);

                        // Salva risposta AI nella history
                        addToHistory('ai', aiText);

                        // Esegui script se presente
                        if (result && typeof result.script === 'string' && result.script.trim() !== '') {
                            try {
                                runActionScript(result.script);
                                const ok = document.createElement('div');
                                ok.className = 'chat-action-result';
                                ok.innerHTML = '✅ Azione eseguita con successo';
                                messagesBox.appendChild(ok);
                                // Non forzare la fine; mantieni posizione corrente
                            } catch (e) {
                                console.error('Error running action script:', e);
                                const err = document.createElement('div');
                                err.className = 'chat-action-error';
                                err.innerHTML = `❌ Errore esecuzione: ${e && e.message ? e.message : 'Errore sconosciuto'}`;
                                messagesBox.appendChild(err);
                                // Non forzare la fine
                                try { window.PROMIUM_CHAT_LOGS = window.PROMIUM_CHAT_LOGS || []; window.PROMIUM_CHAT_LOGS.push({ t: Date.now(), type: 'script_error', msg: e.message }); if (window.PROMIUM_CHAT_LOGS.length > 200) window.PROMIUM_CHAT_LOGS.shift(); } catch (_) { }
                            }
                        }
                    } else {
                        // ============================================
                        // MODALITÀ CHAT NORMALE - Solo domanda/risposta
                        // ============================================
                        const fullMessageWithHistory = historyContextStr + '\n\n' + message;
                        const answer = await answerQuestion(fullMessageWithHistory, requestContext);
                        const aiTimestamp = Date.now();

                        // Mostra risposta AI
                        const aiEl = createAIMessageEl(answer, aiTimestamp);
                        messagesBox.appendChild(aiEl);
                        // Porta in vista l'inizio della risposta
                        scrollToMessageTop(messagesBox, aiEl);

                        // Salva risposta AI nella history
                        addToHistory('ai', answer);
                    }
                } catch (error) {
                    console.error('Error getting answer:', error);
                    const emsg = (error && error.message) ? error.message : 'Impossibile ottenere una risposta.';

                    const errWrapper = document.createElement('div');
                    errWrapper.className = 'chat-msg-ai';
                    errWrapper.innerHTML = `
                        <div>
                            <div class="chat-bubble" style="background: #fff5f5; border-color: #ffc9c9; color: #c92a2a;">
                                ❌ <strong>Errore:</strong> ${escapeHtml(emsg)}
                            </div>
                        </div>
                    `;
                    messagesBox.appendChild(errWrapper);
                    // Non forzare la fine

                    try { window.PROMIUM_CHAT_LOGS = window.PROMIUM_CHAT_LOGS || []; window.PROMIUM_CHAT_LOGS.push({ t: Date.now(), type: 'request_error', msg: emsg }); if (window.PROMIUM_CHAT_LOGS.length > 200) window.PROMIUM_CHAT_LOGS.shift(); } catch (_) { }
                } finally {
                    setRequestInFlight(false);
                }
            }

            sendButton.onclick = function () {
                submitChatMessage();
            };
        }

        if (chatInput) {
            chatInput.oninput = function () {
                inputHandler(this, sendButton)
            };

            chatInput.onfocus = function () {
                maybeShowPromptBuilder();
            };

            chatInput.onclick = function (event) {
                event.stopPropagation();
                maybeShowPromptBuilder();
            };

            chatInput.oncompositionstart = function () {
                window.PROMIUM_CHAT_COMPOSING = true;
            };

            chatInput.oncompositionend = function () {
                window.PROMIUM_CHAT_COMPOSING = false;
            };

            chatInput.onkeydown = function (event) {
                const key = event.key;
                const isComposing = window.PROMIUM_CHAT_COMPOSING;

                if (key === 'Enter' && !isComposing) {
                    if (event.shiftKey) {
                        // Shift + Enter: new line (default behavior, but let's ensure it)
                        // Do nothing, let browser handle newline or append manually if needed
                        // Standard textarea behavior for Shift+Enter is newline.
                    } else {
                        // Enter only: send
                        event.preventDefault();
                        if (runtime.requestInFlight) return;
                        if (sendButton) {
                            sendButton.disabled = true;
                            sendButton.setAttribute('disabled', 'true');
                            sendButton.dataset.busy = '1';
                        }
                        const clickEvent = new Event('click');
                        sendButton.dispatchEvent(clickEvent);
                    }
                }
                
                // Old logic removed for cleaner standard chat behavior

                inputHandler(this, sendButton)
            };
        }

        if (chatContainer && !chatContainer.dataset.promptDismissBound) {
            chatContainer.dataset.promptDismissBound = '1';
            // Click outside to hide removed to prevent flickering
        }

        if (chatHeader) {
            chatHeader.onmousedown = function (event) {
                window.PROMIUM_CHAT_DRAGGING = true;
                const cont = getEl('chat-container');
                if (cont) {
                    cont.style.transform = 'none';
                    const rect = cont.getBoundingClientRect();
                    const left = parseInt(cont.style.left || '', 10);
                    const top = parseInt(cont.style.top || '', 10);
                    const baseLeft = isNaN(left) ? rect.left : left;
                    const baseTop = isNaN(top) ? rect.top : top;
                    cont.style.left = Math.round(baseLeft) + 'px';
                    cont.style.top = Math.round(baseTop) + 'px';
                    window.PROMIUM_CHAT_OFFSET = { x: event.clientX - baseLeft, y: event.clientY - baseTop };
                }
            };
        }
    }

    function ensureChatMounted() {
        const body = document.body;
        if (!body) return false;

        const assistantEls = document.querySelectorAll('#chat-assistant-container');
        const chatEls = document.querySelectorAll('#chat-container');

        for (let i = 1; i < assistantEls.length; i++) assistantEls[i].remove();
        for (let i = 1; i < chatEls.length; i++) chatEls[i].remove();

        const assistant = assistantEls[0] || null;
        const chat = chatEls[0] || null;

        if (!assistant || !chat) {
            if (assistant) assistant.remove();
            if (chat) chat.remove();
            body.insertAdjacentHTML('beforeend', html);
            return true;
        }

        if (assistant.parentNode !== body) body.appendChild(assistant);
        if (chat.parentNode !== body) body.appendChild(chat);

        return true;
    }

    function ensureDelegatedHandlers() {
        if (window.PROMIUM_CHAT_DELEGATED_HANDLERS_ADDED) return;
        window.PROMIUM_CHAT_DELEGATED_HANDLERS_ADDED = true;

        document.addEventListener('click', function (e) {
            const t = e.target;
            const btn = t && t.closest ? t.closest('#prompt-lib-button') : null;
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();
            if (window.PROMIUM_CALC_ACTIONS && typeof window.PROMIUM_CALC_ACTIONS.openWorkbenchAI === 'function') {
                window.PROMIUM_CALC_ACTIONS.openWorkbenchAI();
            } else {
                alert("Workbench AI non disponibile.");
            }
        }, true);
    }

    // Global document listeners (only add once)
    if (!window.PROMIUM_CHAT_GLOBAL_LISTENERS_ADDED) {
        window.PROMIUM_CHAT_DRAGGING = false;
        window.PROMIUM_CHAT_OFFSET = { x: 0, y: 0 };
        window.PROMIUM_CHAT_COMPOSING = false;

        document.addEventListener('mousemove', function (event) {
            if (window.PROMIUM_CHAT_DRAGGING) {
                const chatContainer = getEl('chat-container');
                if (chatContainer) {
                    const margin = 8;
                    const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                    const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                    const w = chatContainer.offsetWidth || 0;
                    const h = chatContainer.offsetHeight || 0;
                    let left = event.clientX - window.PROMIUM_CHAT_OFFSET.x;
                    let top = event.clientY - window.PROMIUM_CHAT_OFFSET.y;
                    const maxLeft = Math.max(margin, vw - w - margin);
                    const maxTop = Math.max(margin, vh - h - margin);
                    left = Math.max(margin, Math.min(maxLeft, left));
                    top = Math.max(margin, Math.min(maxTop, top));
                    chatContainer.style.left = Math.round(left) + 'px';
                    chatContainer.style.top = Math.round(top) + 'px';
                    chatContainer.style.transform = 'none';
                    if (window.PROMIUM_CHAT) window.PROMIUM_CHAT.pos = { left: Math.round(left), top: Math.round(top) };
                }
            }
        });

        document.addEventListener('mouseup', function () {
            window.PROMIUM_CHAT_DRAGGING = false;
            const cont = getEl('chat-container');
            if (cont && cont.style.display !== 'none') clamp(cont);
            try { if (window.PROMIUM_CHAT.updateInputSpacer) window.PROMIUM_CHAT.updateInputSpacer(); } catch(_) {}
        });

        window.addEventListener('resize', function () {
            const cont = getEl('chat-container');
            if (cont && cont.style.display !== 'none') clamp(cont);
            try { if (window.PROMIUM_CHAT.updateInputSpacer) window.PROMIUM_CHAT.updateInputSpacer(); } catch(_) {}
        });

        window.PROMIUM_CHAT_GLOBAL_LISTENERS_ADDED = true;
    }

    if (!window.PROMIUM_CHAT) {
        window.PROMIUM_CHAT = { open: false, pos: { left: null, top: null }, mounted: true };
    }
    if (!window.PROMIUM_CHAT_REQUEST_CLAMP) {
        window.PROMIUM_CHAT_REQUEST_CLAMP = function () {
            const cont = getEl('chat-container');
            if (cont && cont.style.display !== 'none') clamp(cont);
        };
    }

    ensureDelegatedHandlers();
    ensureChatMounted();
    attachChatEvents();

    loadChatAssistantConfig().then(function (config) {
        const titleText = document.getElementById('chat-title-text');
        if (titleText) {
            titleText.textContent = config.chatTitle || 'PROMIUM CALC AI';
        }
    });

    if (!window.PROMIUM_CHAT_OBSERVER) {
        const mo = new MutationObserver(function () {
            if (window.PROMIUM_CHAT_MO_PENDING) return;
            window.PROMIUM_CHAT_MO_PENDING = true;
            requestAnimationFrame(function () {
                window.PROMIUM_CHAT_MO_PENDING = false;
                if (!ensureChatMounted()) return;
                attachChatEvents();
            });
        });

        try { mo.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) { }
        window.PROMIUM_CHAT_OBSERVER = mo;
    }
}

const needChatHosts = []
function isNeedChat() {
    return true
}


function setFormuala(sentence = '') {

    let link = getLink(sentence)

    if (link !== '') {
        setGET_AIRTABLE(link)
    } else {
        setASK_AI(sentence)
    }

}

function setASK_AI(sentence = '') {

    let range = getRange(sentence);

    range = range === '' ? '' : ',' + range
    const data = [
        [
            {
                "f": "=ASK_AI(\\\"" + sentence + "\\\"" + range + ")"
            }
        ]
    ]
    luckysheet.setRangeValue(data)
}

function setGET_AIRTABLE(link) {
    const data = [
        [
            {
                "f": "=GET_AIRTABLE_DATA(\\\"" + link + "\\\")"
            }
        ]
    ]
    luckysheet.setRangeValue(data)
}

function getLink(sentence = '') {
    const regex = /(https?:\/\/(?:www\.)?airtable\.com\/\S+)/gi;
    const matches = sentence.match(regex);

    if (matches) {
        return matches[0];
    }

    return ''

}

function getRange(text) {
    const regex = /([A-Z]+[0-9]*):([A-Z]+[0-9]*)/g;
    const matche = text.match(regex);
    if (matche) {
        return matche[0]
    }
    return ''
}

function toA1(r, c) {
    let col = '';
    let n = c + 1;
    while (n > 0) {
        n -= 1;
        col = String.fromCharCode(65 + (n % 26)) + col;
        n = Math.floor(n / 26);
    }
    return col + (r + 1);
}

function normalizeHeader(s) {
    if (s == null) return '';
    return String(s).toLowerCase().replace(/\s+/g, ' ').trim();
}

function colLetterToIndex(letter) {
    let s = String(letter || '').toUpperCase();
    if (!s) return -1;
    let n = 0;
    for (let i = 0; i < s.length; i++) {
        n = n * 26 + (s.charCodeAt(i) - 64);
    }
    return n - 1;
}

function parseNonNegativeInteger(value, label) {
    const normalized = Number(value);
    if (!Number.isInteger(normalized) || normalized < 0) {
        throw new Error(label + ' non valido: usa un intero maggiore o uguale a 0.');
    }
    return normalized;
}

function normalizeWorkbenchOrientation(value) {
    const normalized = String(value || 'horizontal').trim().toLowerCase();
    if (normalized !== 'horizontal' && normalized !== 'vertical') {
        throw new Error('ORIENTAMENTO non valido: usa "horizontal" oppure "vertical".');
    }
    return normalized;
}

/**
 * Opzioni del contesto salvate insieme a un prompt (campo "configuration"
 * del Workbench AI: offsetRow, offsetCol, cols, orientation, includeHeaders),
 * tradotte nelle opzioni di collectSheetDataAsCSV.
 *
 * PERCHÉ: un prompt suggerito è scritto per una precisa forma del contesto.
 * Il prompt "Calcola Preventivo" di AeV, per esempio, cita le colonne per
 * lettera e funziona solo se le intestazioni le riportano (includeHeaders).
 * Prima la chat applicava la configurazione solo se l'operatore aveva aperto
 * il Workbench: scegliendo il suggerimento direttamente dalla chat il contesto
 * partiva senza lettere.
 *
 * ignoreWorkbench: la configurazione del prompt vale per intero, anche per le
 * chiavi lasciate vuote (cols "" = tutte le colonne). Senza, una selezione di
 * colonne fatta nel Workbench per un altro prompt verrebbe ereditata.
 *
 * Ritorna null se la configurazione non contiene opzioni di contesto (per
 * esempio solo isDisabled/autoPasteText): vale il comportamento di sempre.
 */
function promptContextOptions(config) {
    if (!config || typeof config !== 'object') return null;
    const opts = {};
    if (config.offsetRow !== undefined && config.offsetRow !== null && config.offsetRow !== '') opts.headerRow = Number(config.offsetRow);
    if (config.offsetCol !== undefined && config.offsetCol !== null && config.offsetCol !== '') opts.offsetCol = Number(config.offsetCol);
    if (typeof config.cols === 'string') opts.columns = config.cols;
    if (typeof config.orientation === 'string' && config.orientation) opts.orientation = config.orientation;
    if (typeof config.includeHeaders === 'boolean') opts.includeHeaders = config.includeHeaders;
    if (config.format === 'cells' || config.format === 'table') opts.format = config.format;
    if (Object.keys(opts).length === 0) return null;
    opts.ignoreWorkbench = true;
    return opts;
}

const NUMERIC_TEXT = /^\s*[-+]?(\d+\.?\d*|\.\d+)([eE][-+]?\d+)?\s*$/;

/**
 * Valore di una cella per il contesto AI: quello mostrato (m), come sempre,
 * tranne un caso. Una cella numerica in formato Generale il cui valore è un
 * TESTO — numeri piccoli che Excel salva in notazione scientifica,
 * "5.0000000000000001E-3" — viene mostrata dal core come "-5.000000000":
 * all'AI arriverebbe un numero negativo e sbagliato. Lì si usa il numero vero,
 * senza il rumore del binario (15 cifre significative: 0.31989999999999996 ->
 * "0.3199"). Gli altri formati (es. percentuali) il core li mostra bene e
 * restano come sono; le celle di testo (ct.t "s"/"inlineStr") pure.
 *
 * Il file importato da adesso in poi è già corretto da
 * promium/loader/xlsxNumberFixLoader.js; questo copre i documenti salvati
 * prima (es. workbook collaborativi già sul database).
 *
 * Testo su più righe (a capo dentro la cella, ct.t "inlineStr"): il testo sta
 * nei frammenti ct.s[].v e la cella non ha né v né m. Prima arrivava VUOTO
 * all'AI: nel listino AeV erano ~1.300 descrizioni di casse e bancali.
 *
 * Spazi e a capo all'INIZIO e alla FINE di un testo si tolgono: sono
 * formattazione di Excel, non contenuto, e diventavano un "<br>" in coda alla
 * descrizione. Con una richiesta reale il modello ha scartato il bancale
 * "EURO CPR 80 x 120<br>" perché non coincideva con "EURO CPR 80 x 120"
 * scritto dall'operatore. Gli a capo interni restano (diventano <br>).
 */
function aiCellValue(cell) {
    const c = (cell && cell.v && typeof cell.v === 'object') ? cell.v : cell;
    if (!c) return '';
    const ct = c.ct || {};
    if (ct.t === 'inlineStr' && Array.isArray(ct.s) && c.m == null && c.v == null) {
        return ct.s.map(function (r) { return r && r.v != null ? String(r.v) : ''; }).join('').trim();
    }
    if (typeof c.v === 'string' && (!ct.t || ct.t === 'n') && (!ct.fa || ct.fa === 'General') && NUMERIC_TEXT.test(c.v)) {
        const n = Number(c.v);
        if (isFinite(n)) return String(parseFloat(n.toPrecision(15)));
    }
    const valore = c.m || c.v || '';
    return typeof valore === 'string' ? valore.trim() : valore;
}

function transposeGrid(grid) {
    if (!Array.isArray(grid) || grid.length === 0) return [];
    const sourceRows = grid.length;
    const sourceCols = Math.max.apply(null, grid.map(function (row) {
        return Array.isArray(row) ? row.length : 0;
    }));
    const transposed = Array(sourceCols).fill(null).map(function () {
        return Array(sourceRows).fill(null).map(function () {
            return { value: '', raw: null };
        });
    });

    for (let r = 0; r < sourceRows; r++) {
        for (let c = 0; c < sourceCols; c++) {
            const sourceCell = grid[r] && grid[r][c] ? grid[r][c] : { value: '', raw: null };
            transposed[c][r] = {
                value: sourceCell.value,
                raw: sourceCell.raw
            };
        }
    }

    return transposed;
}

/**
 * ============================================
 * COLLECT SHEET DATA - Raccolta dati foglio Excel
 * ============================================
 * Questa funzione raccoglie i dati del foglio attivo di Luckysheet.
 * 
 * COMPORTAMENTO:
 * - Se NON ci sono impostazioni workbench attive -> legge TUTTO il foglio
 * - Se ci sono impostazioni workbench con colonne specificate -> filtra SOLO quelle colonne
 * - L'offset riga definisce dove si trova la riga header (per inferenza), NON filtra i dati
 * 
 * Parametri celle Luckysheet supportati (da documentazione):
 * - v: valore originale della cella
 * - m: valore visualizzato formattato
 * - f: formula (se presente)
 * - ct: formato cella { fa: formato, t: tipo (n=numero, s=stringa, d=data, b=boolean) }
 * - bg: colore sfondo
 * - fc: colore testo
 * - bl: grassetto (1=sì)
 * - it: corsivo (1=sì)
 * 
 * @param {Object} opts - Opzioni di configurazione
 * @param {number} opts.headerRow - Riga che contiene gli header (0-based), default 0
 * @param {string} opts.columns - Stringa colonne da includere es. "A:D,G,L:N" (null = tutte)
 * @param {boolean} opts.includeMetadata - Se includere metadati cella (default: false)
 * @param {number} opts.offsetCol - Colonna iniziale da includere (0-based)
 * @param {Array<string>} opts.bannedHeaders - Intestazioni da escludere
 * @param {boolean} opts.ignoreWorkbench - Non ereditare la config del Workbench (vedi promptContextOptions)
 * @param {string} opts.format - 'table' (predefinito): tabella Markdown; 'cells': una riga di testo per
 *   riga del foglio con le sole celle non vuote, come "R10: AF=4025 | AG=POKER". Per fogli larghi con
 *   molte celle vuote: in tabella il modello deve contare i separatori "| |" per sapere in che colonna
 *   si trova un valore e sbaglia (verificato con il listino AeV, 227 colonne); qui ogni valore porta
 *   la sua lettera. Ed è anche più corto, perché le celle vuote non si scrivono.
 * @returns {string} Dati in formato tabella Markdown (o righe di celle, con format 'cells')
 */
function collectSheetDataAsCSV(opts = {}) {
    // Override defaults with Workbench config if active (from menuLoader.js)
    try {
        if (window.PROMIUM_WB_LAST_CONFIG && !opts.ignoreWorkbench) {
            if (typeof opts.headerRow === 'undefined' && typeof window.PROMIUM_WB_LAST_CONFIG.headerRow === 'number') {
                opts.headerRow = window.PROMIUM_WB_LAST_CONFIG.headerRow;
            }
            if (typeof opts.offsetCol === 'undefined' && typeof window.PROMIUM_WB_LAST_CONFIG.offsetCol === 'number') {
                opts.offsetCol = window.PROMIUM_WB_LAST_CONFIG.offsetCol;
            }
            if (!opts.columns && window.PROMIUM_WB_LAST_CONFIG.columns) {
                opts.columns = window.PROMIUM_WB_LAST_CONFIG.columns;
            }
            if (typeof opts.orientation === 'undefined' && typeof window.PROMIUM_WB_LAST_CONFIG.orientation === 'string') {
                opts.orientation = window.PROMIUM_WB_LAST_CONFIG.orientation;
            }
            if (typeof opts.includeHeaders === 'undefined' && typeof window.PROMIUM_WB_LAST_CONFIG.includeHeaders === 'boolean') {
                opts.includeHeaders = window.PROMIUM_WB_LAST_CONFIG.includeHeaders;
            }
            if (typeof opts.format === 'undefined' && typeof window.PROMIUM_WB_LAST_CONFIG.format === 'string') {
                opts.format = window.PROMIUM_WB_LAST_CONFIG.format;
            }
        }
    } catch(e) {}
    if (typeof opts.headerRow === 'undefined' && typeof opts.skipRows === 'number') {
        opts.headerRow = opts.skipRows;
    }

    // Ottieni i dati del foglio corrente in modo robusto anche dopo cambio file
    let data = null;
    try {
        if (window.luckysheet && typeof window.luckysheet.getSheetData === 'function') {
            const currentData = window.luckysheet.getSheetData();
            if (Array.isArray(currentData) && currentData.length > 0) {
                data = currentData;
            }
        }
    } catch (e) {}

    if (!Array.isArray(data) || data.length === 0) {
        try {
            const fileArr = (window.luckysheet && typeof window.luckysheet.getluckysheetfile === 'function')
                ? window.luckysheet.getluckysheetfile()
                : [];
            let sheet = (window.luckysheet && typeof window.luckysheet.getSheet === 'function')
                ? window.luckysheet.getSheet()
                : null;

            if (!sheet || !Array.isArray(sheet.data) || sheet.data.length === 0) {
                const firstVisibleSheet = Array.isArray(fileArr)
                    ? fileArr.find(function (s) { return s && (s.status == 1) && Array.isArray(s.data) && s.data.length > 0; })
                    : null;
                const firstNonEmptySheet = Array.isArray(fileArr)
                    ? fileArr.find(function (s) { return s && Array.isArray(s.data) && s.data.length > 0; })
                    : null;
                sheet = firstVisibleSheet || firstNonEmptySheet || (Array.isArray(fileArr) && fileArr.length ? fileArr[0] : null);
            }

            if (sheet && Array.isArray(sheet.data)) {
                data = sheet.data;
            }
        } catch (e) {}
    }

    if (!Array.isArray(data) || data.length === 0) {
        console.warn('[collectSheetDataAsCSV] Nessun foglio attivo o dati non disponibili');
        return '';
    }

    // ============================================
    // STEP 1: Costruisci la griglia dati
    // ============================================
    let grid;
    let rows, cols;

    if (Array.isArray(data[0])) {
        // Formato array 2D
        rows = data.length;
        cols = Math.max(...data.map(r => (Array.isArray(r) ? r.length : 0)));
        grid = Array(rows).fill(null).map(() => Array(cols).fill(null));

        for (let r = 0; r < rows; r++) {
            const row = data[r] || [];
            for (let c = 0; c < cols; c++) {
                const cell = row[c];
                if (cell) {
                    // Estrai valore con fallback
                    const value = aiCellValue(cell);

                    // Salva sia valore che metadati per uso futuro
                    grid[r][c] = {
                        value: value ?? '',
                        raw: cell
                    };
                } else {
                    grid[r][c] = { value: '', raw: null };
                }
            }
        }
    } else {
        // Formato celldata (array di oggetti con r, c)
        let maxRow = 0;
        let maxCol = 0;
        for (const cell of data) {
            const r = typeof cell.r === 'number' ? cell.r : 0;
            const c = typeof cell.c === 'number' ? cell.c : 0;
            if (r > maxRow) maxRow = r;
            if (c > maxCol) maxCol = c;
        }

        rows = maxRow + 1;
        cols = maxCol + 1;
        grid = Array(rows).fill(null).map(() => Array(cols).fill(null));

        for (let r = 0; r < rows; r++) {
            for (let c = 0; c < cols; c++) {
                grid[r][c] = { value: '', raw: null };
            }
        }

        for (const cell of data) {
            const r = typeof cell.r === 'number' ? cell.r : 0;
            const c = typeof cell.c === 'number' ? cell.c : 0;
            const value = aiCellValue(cell);
            if (grid[r]) {
                grid[r][c] = { value: value ?? '', raw: cell };
            }
        }
    }

    if (!grid || grid.length === 0) {
        console.warn('[collectSheetDataAsCSV] Griglia vuota');
        return '';
    }

    const orientation = normalizeWorkbenchOrientation(opts.orientation);
    if (orientation === 'vertical') {
        grid = transposeGrid(grid);
        rows = grid.length;
        cols = rows > 0 ? grid[0].length : 0;
    }

    // ============================================
    // STEP 2: Determina quali colonne includere
    // ============================================
    const headerRow = parseNonNegativeInteger(typeof opts.headerRow === 'undefined' ? 0 : opts.headerRow, 'OFFSET RIGA');
    if (headerRow >= grid.length) {
        throw new Error('OFFSET RIGA fuori range: massimo consentito ' + Math.max(grid.length - 1, 0) + '.');
    }
    const columnsStr = opts.columns || null;

    // Parsing colonne selezionate (es. "A:D,G,L:N")
    let selectedColIndices = null; // null = tutte

    if (columnsStr && columnsStr.trim()) {
        selectedColIndices = new Set();
        const parts = columnsStr.split(',');

        parts.forEach(p => {
            p = p.trim();
            if (!p) return;
            if (!/^[A-Za-z]+(:[A-Za-z]+)?$/.test(p)) {
                throw new Error('COLONNE non valido: usa solo lettere o intervalli tipo A:D,G,L:N,P.');
            }
            if (p.indexOf(':') > -1) {
                // Range (es. A:D)
                const range = p.split(':');
                const start = colLetterToIndex(range[0]);
                const end = colLetterToIndex(range[1]);
                if (start < 0 || end < 0 || start >= cols || end >= cols) {
                    throw new Error('COLONNE fuori range: il foglio orientato contiene ' + cols + ' colonne.');
                }
                for (let i = Math.min(start, end); i <= Math.max(start, end); i++) {
                    selectedColIndices.add(i);
                }
            } else {
                // Singola colonna
                const idx = colLetterToIndex(p);
                if (idx < 0 || idx >= cols) {
                    throw new Error('COLONNE fuori range: il foglio orientato contiene ' + cols + ' colonne.');
                }
                selectedColIndices.add(idx);
            }
        });

        if (selectedColIndices.size === 0) {
            throw new Error('COLONNE non valido: specifica almeno una colonna utile.');
        }
    }

    const offsetCol = parseNonNegativeInteger(typeof opts.offsetCol === 'undefined' ? 0 : opts.offsetCol, 'OFFSET COLONNA');
    if (offsetCol >= cols) {
        throw new Error('OFFSET COLONNA fuori range: massimo consentito ' + Math.max(cols - 1, 0) + '.');
    }
    const bannedHeaderSet = new Set(
        (Array.isArray(opts.bannedHeaders) ? opts.bannedHeaders : [])
            .map(normalizeHeader)
            .filter(Boolean)
    );

    function hasMeaningfulValue(value) {
        return String(value == null ? '' : value).replace(/\u00a0/g, ' ').trim() !== '';
    }

    function escapeMarkdownCell(value) {
        return String(value == null ? '' : value)
            .replace(/\r?\n/g, '<br>')
            .replace(/\|/g, '\\|');
    }

    function getColumnLetter(c) {
        let colName = '';
        let n = c;
        while (n >= 0) {
            colName = String.fromCharCode(65 + (n % 26)) + colName;
            n = Math.floor(n / 26) - 1;
        }
        return colName;
    }

    const hasHeaderRow = headerRow >= 0 && headerRow < grid.length;
    const includeColumnLetters = (typeof opts.includeHeaders === 'boolean')
        ? opts.includeHeaders
        : !!(
            (window.PROMIUM_AI_CONFIG && window.PROMIUM_AI_CONFIG.includeHeaders) ||
            (!opts.ignoreWorkbench && window.PROMIUM_WB_LAST_CONFIG && window.PROMIUM_WB_LAST_CONFIG.includeHeaders)
        );

    // Costruisci le colonne candidate rispettando configurazione, offset e filtri.
    const effectiveColumns = [];
    for (let c = 0; c < cols; c++) {
        if (c < offsetCol) continue;
        if (selectedColIndices && !selectedColIndices.has(c)) continue;
        if (hasHeaderRow && bannedHeaderSet.size > 0) {
            const headerValue = normalizeHeader(grid[headerRow][c] ? grid[headerRow][c].value : '');
            if (headerValue && bannedHeaderSet.has(headerValue)) continue;
        }
        effectiveColumns.push(c);
    }

    // Elimina solo le colonne vuote finali: quelle interne restano, le terminali no.
    while (effectiveColumns.length > 0) {
        const lastCol = effectiveColumns[effectiveColumns.length - 1];
        let hasDataInColumn = false;
        for (let r = 0; r < grid.length; r++) {
            if (hasMeaningfulValue(grid[r][lastCol] ? grid[r][lastCol].value : '')) {
                hasDataInColumn = true;
                break;
            }
        }
        if (hasDataInColumn) break;
        effectiveColumns.pop();
    }

    if (effectiveColumns.length === 0) {
        throw new Error('La combinazione di OFFSET COLONNA e COLONNE non produce nessuna colonna valida.');
    }

    if (opts.format === 'cells') {
        // Righe dalla riga intestazioni (OFFSET RIGA) in giù; R = numero di riga del
        // foglio orientato (con orientamento orizzontale coincide con quello del foglio).
        const cellLines = ['Formato: una riga per riga del foglio (R = numero di riga), solo le celle non vuote, come COLONNA=valore.'];
        for (let r = headerRow; r < grid.length; r++) {
            const parts = [];
            effectiveColumns.forEach(function (c) {
                const value = String((grid[r][c] && grid[r][c].value) || '');
                if (hasMeaningfulValue(value)) parts.push(getColumnLetter(c) + '=' + escapeMarkdownCell(value));
            });
            if (parts.length) cellLines.push('R' + (r + 1) + ': ' + parts.join(' | '));
        }
        return cellLines.join('\n');
    }

    const rawHeaderValues = hasHeaderRow
        ? effectiveColumns.map(function (c) { return String((grid[headerRow][c] && grid[headerRow][c].value) || '').trim(); })
        : [];
    const hasNamedHeaders = rawHeaderValues.some(hasMeaningfulValue);

    const tableHeaders = effectiveColumns.map(function (c, idx) {
        const letter = includeColumnLetters ? getColumnLetter(c) : '';
        const headerText = hasNamedHeaders ? rawHeaderValues[idx] : '';
        if (letter && headerText) return `${letter} - ${headerText}`;
        if (headerText) return headerText;
        if (letter) return letter;
        return `Colonna ${c + 1}`;
    });

    const outputLines = [];
    outputLines.push('| ' + tableHeaders.map(escapeMarkdownCell).join(' | ') + ' |');
    outputLines.push('| ' + tableHeaders.map(function () { return '---'; }).join(' | ') + ' |');

    const dataStartRow = hasNamedHeaders ? headerRow + 1 : 0;
    for (let r = dataStartRow; r < grid.length; r++) {
        const rowValues = effectiveColumns.map(function (c) {
            return String((grid[r][c] && grid[r][c].value) || '');
        });
        if (!rowValues.some(hasMeaningfulValue)) continue;
        outputLines.push('| ' + rowValues.map(escapeMarkdownCell).join(' | ') + ' |');
    }

    return outputLines.join('\n');
}

/**
 * Calcola metadati di integrità per il contesto inviato al backend.
 * 
 * SCOPO:
 * Garantire che il contesto ricevuto dall'AI sia esattamente identico a quello inviato dal browser.
 * Previene errori subdoli dovuti a troncamento del payload (es. limiti proxy/server) che porterebbero
 * l'AI a ragionare su dati parziali senza accorgersene.
 * 
 * DATI CALCOLATI:
 * - byte_length: dimensione esatta in byte UTF-8
 * - line_count: numero di righe
 * - sha256: hash crittografico del contenuto
 */
async function buildContextIntegrityMeta(contextStr) {
    // Usa l'argomento locale ricevuto dalla funzione: qui la variabile `context`
    // non esiste nello scope del helper e generava ReferenceError a runtime.
    const text = String(contextStr || '');
    const byteLength = new TextEncoder().encode(text).length;
    const lineCount = text ? text.split(/\r?\n/).length : 0;
    let sha256 = null;
    try {
        if (window.crypto && window.crypto.subtle) {
            const encoded = new TextEncoder().encode(text);
            const digest = await window.crypto.subtle.digest('SHA-256', encoded);
            const arr = Array.from(new Uint8Array(digest));
            sha256 = arr.map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
        }
    } catch (e) { }
    return {
        byte_length: byteLength,
        line_count: lineCount,
        sha256: sha256
    };
}

export async function answerQuestion(q, context = null) {
    const securityKey = 'bYrtGMlKH649wwRglPoCGplBgZv8NgDEnVom'; // La stessa chiave del backend

    // Se non viene fornito un contesto esplicito, usa il builder senza offset legacy nascosti.
    if (context === null) {
        context = collectSheetDataAsCSV({
            bannedHeaders: ['telefono', 'cellulare', 'email', 'mail', 'codice fiscale', 'cap', 'indirizzo', 'punto vendita']
        });
    }
    const contextMeta = await buildContextIntegrityMeta(context);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 300000); // 5 minuti timeout

    try {
        const response = await fetch('/api/chatbotgenerico/chat', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${securityKey}`
            },
            body: JSON.stringify({ question: q, context: context, context_meta: contextMeta }),
            signal: controller.signal
        });
        clearTimeout(timeoutId);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || 'Unknown error');
        }

        const data = await response.json();
        return data.response;
    } catch (e) {
        clearTimeout(timeoutId);
        if (e.name === 'AbortError') {
            throw new Error('Timeout: la richiesta ha impiegato più di 5 minuti.');
        }
        throw e;
    }
}

async function chatAction(q, context = null) {
    const securityKey = 'bYrtGMlKH649wwRglPoCGplBgZv8NgDEnVom';
    if (context === null) {
        context = collectSheetDataAsCSV({
            bannedHeaders: ['telefono', 'cellulare', 'email', 'mail', 'codice fiscale', 'cap', 'indirizzo', 'punto vendita']
        });
    }
    const contextMeta = await buildContextIntegrityMeta(context);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 300000); // 5 minuti timeout



    try {
        const response = await fetch('/api/chat_action', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': securityKey
            },
            body: JSON.stringify({ query: q, context: context, context_meta: contextMeta }),
            signal: controller.signal
        });
        clearTimeout(timeoutId);

        if (!response.ok) {
            let msg = '';
            try {
                const errorData = await response.json();
                msg = errorData.detail || errorData.message || JSON.stringify(errorData);
            } catch (e) {
                try { msg = await response.text(); } catch (_) { }
            }
            throw new Error(`HTTP ${response.status}: ${msg || 'Unknown error'}`);
        }
        return await response.json();
    } catch (e) {
        clearTimeout(timeoutId);
        if (e.name === 'AbortError') {
            throw new Error('Timeout: la richiesta ha impiegato più di 5 minuti.');
        }
        throw e;
    }
}

function runActionScript(code) {
    const fn = new Function(code);
    const r = fn();
    if (typeof window !== 'undefined') {
        window.PROMIUM_CHAT_LOGS = window.PROMIUM_CHAT_LOGS || [];
        window.PROMIUM_CHAT_LOGS.push({ t: Date.now(), type: 'action', code: String(code).slice(0, 4000), r });
        if (window.PROMIUM_CHAT_LOGS.length > 200) { window.PROMIUM_CHAT_LOGS.shift(); }
    }
    return r;
}

function renderMarkdown(md) {
    if (!md || typeof md !== 'string') return '';
    function esc(s) {
        return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function findMatchingBrace(str, startIndex) {
        let depth = 0;
        for (let i = startIndex; i < str.length; i++) {
            const ch = str[i];
            if (ch === '{') depth++;
            if (ch === '}') {
                depth--;
                if (depth === 0) return i;
            }
        }
        return -1;
    }
    function wrapMathCommand(content, className) {
        return `<span class="${className}">${renderLatexFragment(content)}</span>`;
    }
    function renderLatexFragment(source) {
        let html = '';
        let i = 0;
        while (i < source.length) {
            if (source.startsWith('\\frac{', i)) {
                const numStart = i + 5;
                const numEnd = findMatchingBrace(source, numStart);
                if (numEnd !== -1 && source[numEnd + 1] === '{') {
                    const denStart = numEnd + 1;
                    const denEnd = findMatchingBrace(source, denStart);
                    if (denEnd !== -1) {
                        const numerator = source.slice(numStart + 1, numEnd);
                        const denominator = source.slice(denStart + 1, denEnd);
                        html += `<span class="chat-fraction"><span class="chat-frac-top">${renderLatexFragment(numerator)}</span><span class="chat-frac-bottom">${renderLatexFragment(denominator)}</span></span>`;
                        i = denEnd + 1;
                        continue;
                    }
                }
            }
            if (source.startsWith('\\textbf{', i)) {
                const start = i + 7;
                const end = findMatchingBrace(source, start);
                if (end !== -1) {
                    html += `<strong>${renderLatexFragment(source.slice(start + 1, end))}</strong>`;
                    i = end + 1;
                    continue;
                }
            }
            if (source.startsWith('\\text{', i)) {
                const start = i + 5;
                const end = findMatchingBrace(source, start);
                if (end !== -1) {
                    html += wrapMathCommand(source.slice(start + 1, end), 'chat-math-text');
                    i = end + 1;
                    continue;
                }
            }
            if (source.startsWith('\\approx', i)) { html += '&asymp;'; i += 7; continue; }
            if (source.startsWith('\\cdot', i)) { html += '&middot;'; i += 5; continue; }
            if (source.startsWith('\\times', i)) { html += '&times;'; i += 6; continue; }
            if (source.startsWith('\\leq', i)) { html += '&le;'; i += 4; continue; }
            if (source.startsWith('\\geq', i)) { html += '&ge;'; i += 4; continue; }
            if (source.startsWith('\\neq', i)) { html += '&ne;'; i += 4; continue; }
            if (source.startsWith('\\\\', i)) { html += '<br>'; i += 2; continue; }
            if (source[i] === '\\') {
                const cmd = source.slice(i).match(/^\\[a-zA-Z]+/);
                if (cmd) {
                    html += esc(cmd[0].slice(1));
                    i += cmd[0].length;
                    continue;
                }
            }
            html += esc(source[i]);
            i++;
        }
        return html;
    }
    function renderDisplayMathBlock(expr) {
        const lines = expr
            .split(/\r?\n/)
            .map(function (line) { return line.trim(); })
            .filter(function (line) { return line.length > 0; });
        const body = lines.map(function (line) {
            return `<div class="chat-math-line">${renderLatexFragment(line)}</div>`;
        }).join('');
        return `<div class="chat-math-block">${body}</div>`;
    }
    function inline(s) {
        let t = esc(s);
        t = t.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
        t = t.replace(/(^|[^*])\*(?!\s)(.+?)\*(?!\*)/g, '$1<em>$2</em>');
        t = t.replace(/`([^`]+?)`/g, '<code>$1</code>');
        t = t.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="nofollow noopener">$1</a>');
        return t;
    }
    const mathBlocks = [];
    const normalizedMd = md.replace(/\\\[(.*?)\\\]/gs, function (_match, expr) {
        const token = `@@CHAT_MATH_BLOCK_${mathBlocks.length}@@`;
        mathBlocks.push(renderDisplayMathBlock(expr));
        return '\n' + token + '\n';
    });
    const lines = normalizedMd.split(/\r?\n/);
    let html = '';
    let inCode = false;
    let ulOpen = false, olOpen = false;
    function closeLists() {
        if (ulOpen) { html += '</ul>'; ulOpen = false; }
        if (olOpen) { html += '</ol>'; olOpen = false; }
    }
    for (let idx = 0; idx < lines.length; idx++) {
        let line = lines[idx];
        if (/^```/.test(line)) {
            if (!inCode) { closeLists(); html += '<pre><code>'; inCode = true; }
            else { html += '</code></pre>'; inCode = false; }
            continue;
        }
        if (inCode) { html += esc(line) + '\n'; continue; }
        const mathToken = line.trim().match(/^@@CHAT_MATH_BLOCK_(\d+)@@$/);
        if (mathToken) {
            closeLists();
            html += mathBlocks[Number(mathToken[1])] || '';
            continue;
        }
        // Table: header + separator + rows
        if (/^\s*\|.+\|\s*$/.test(line) && idx + 1 < lines.length && /^\s*\|?\s*:?-{3,}.*\|\s*$/.test(lines[idx + 1])) {
            const headerCells = line.trim().slice(1, -1).split('|').map(c => inline(c.trim()));
            idx++;
            const rows = [];
            while (idx + 1 < lines.length && /^\s*\|.+\|\s*$/.test(lines[idx + 1])) {
                const rowLine = lines[idx + 1];
                const rowCells = rowLine.trim().slice(1, -1).split('|').map(c => inline(c.trim()));
                rows.push('<tr>' + rowCells.map(c => '<td style="border:1px solid #dee2e6;padding:6px;">' + c + '</td>').join('') + '</tr>');
                idx++;
            }
            html += '<table style="width:100%;border-collapse:collapse;"><thead><tr>' + headerCells.map(c => '<th style="border:1px solid #dee2e6;padding:6px;background:#f8f9fa;">' + c + '</th>').join('') + '</tr></thead><tbody>' + rows.join('') + '</tbody></table>';
            continue;
        }
        const h = line.match(/^#{1,6}\s+(.*)$/);
        if (h) {
            closeLists();
            const lvl = (line.match(/^#{1,6}/)[0] || '#').length;
            html += `<h${lvl}>${inline(h[1])}</h${lvl}>`;
            continue;
        }
        if (/^\s*[-*]\s+/.test(line)) {
            if (!ulOpen) { closeLists(); html += '<ul>'; ulOpen = true; }
            html += `<li>${inline(line.replace(/^\s*[-*]\s+/, ''))}</li>`;
            continue;
        }
        if (/^\s*\d+\.\s+/.test(line)) {
            if (!olOpen) { closeLists(); html += '<ol>'; olOpen = true; }
            html += `<li>${inline(line.replace(/^\s*\d+\.\s+/, ''))}</li>`;
            continue;
        }
        if (line.trim() === '') { closeLists(); continue; }
        closeLists();
        html += `<p>${inline(line)}</p>`;
    }
    closeLists();
    return html;
}
